(function () {
  document.documentElement.classList.add("n22-new-header");
  document.body.classList.add("n22-new-header-active");
  window.__22N_CONFIG__ = window.__22N_CONFIG__ || {};
  if (!window.__22N_CONFIG__.shop) {
    window.__22N_CONFIG__.shop = window.Shopify && Shopify.shop
      ? ("https://" + (window.Shopify.shop.includes(".") ? Shopify.shop : "22nationshop.com"))
      : "https://22nationshop.com";
  }
  if (!window.__22N_CONFIG__.imagesBase) {
    var logoAsset = document.querySelector("#site-logo");
    if (logoAsset && logoAsset.getAttribute("src")) {
      var src = logoAsset.getAttribute("src").split("?")[0];
      window.__22N_CONFIG__.logoUrl = src.indexOf("//") === 0 ? "https:" + src : src;
      window.__22N_CONFIG__.imagesBase = window.__22N_CONFIG__.logoUrl.replace(/22N-logo\.png$/, "");
    }
  }
  if (!window.__22N_CONFIG__.cache) window.__22N_CONFIG__.cache = "4";
  if (!window.__22N_CONFIG__.cdn) window.__22N_CONFIG__.cdn = window.__22N_CONFIG__.imagesBase || "";
})();

(function () {

    function syncLandingViewportMode() {
      var mq = window.matchMedia("(max-width: 768px)");
      function apply() {
        document.body.classList.toggle("mobile-landing", mq.matches);
      }
      apply();
      if (mq.addEventListener) mq.addEventListener("change", apply);
      else if (mq.addListener) mq.addListener(apply);
    }
    syncLandingViewportMode();
    var CDN = window.__22N_CONFIG__.cdn;
    var CACHE = window.__22N_CONFIG__.cache || "4";
    var SHOP = window.__22N_CONFIG__.shop;
    var SHOP_STOREFRONT_TOKEN = "dc47847145fc8613e334514f91c9ffcf";
    var SHOP_COLOR_PAGE = SHOP + "/collections/shop-all";
    function shopProductUrl(handle) {
      return SHOP + "/collections/shop-all/products/" + handle;
    }
    var LEGACY_PRODUCT_LINKS = {
      "/collections/matching-sets": "red-means-go-set",
      "/collections/leggings": "rose-ballet-high-waist-legging"
    };
    function canonicalShopUrl(url) {
      if (!url) return SHOP;
      var trimmed = String(url).trim();
      var absolute = /^https?:\/\//i.test(trimmed)
        ? trimmed
        : (trimmed.charAt(0) === "/" ? SHOP + trimmed : SHOP + "/" + trimmed);
      var path = absolute.replace(/^https?:\/\/[^/]+/i, "");
      var legacyHandle = LEGACY_PRODUCT_LINKS[path] || LEGACY_PRODUCT_LINKS[path.replace(/\/$/, "")];
      if (legacyHandle) return shopProductUrl(legacyHandle);
      var shopAllMatch = path.match(/\/collections\/shop-all\/products\/([^/?#]+)/i);
      if (shopAllMatch) return shopProductUrl(shopAllMatch[1]);
      var productMatch = path.match(/\/products\/([^/?#]+)/i);
      if (productMatch) return shopProductUrl(productMatch[1]);
      return absolute;
    }
    var FEATURED_SECTIONS = [
      "feature_row_xTdPpp",
      "feature_row_JzVGmA",
      "feature_row_TQHBTf",
      "feature_row_D77pRE"
    ];
    var FEATURED_HANDLE_OVERRIDES = {
      "rose-ballet-high-waist-legging": "rose-ballet-wrap-top"
    };
    /* Back In Stock — live prices sync from Shopify on every page load */
    var BACK_IN_STOCK_SLOTS = [
      {
        sourceHandle: "berry-mood-straight-leg-pant",
        title: "Berry Mood Set",
        url: SHOP + "/collections/berry-mood-set",
        image: "https://cdn.shopify.com/s/files/1/0500/3132/9438/files/FEFCE5C6-2382-45AB-A00B-117CF1E60FF1.jpg?v=1778439042",
        priceCollection: "berry-mood-set",
        priceHandles: ["berry-mood-tank-top", "berry-mood-straight-leg-pant"]
      },
      {
        sourceHandle: "rose-ballet-sports-bra",
        title: "Rose Ballet Set",
        url: SHOP + "/collections/rose-ballet-set",
        image: "https://cdn.shopify.com/s/files/1/0500/3132/9438/files/IMG-0679.png?v=1778623968",
        priceCollection: "rose-ballet-set",
        priceHandles: ["rose-ballet-wrap-top", "rose-ballet-sports-bra"]
      },
      {
        sourceHandle: "buttercream-sports-bra",
        title: "Buttercream Set",
        url: SHOP + "/collections/buttercream-edit",
        image: "https://cdn.shopify.com/s/files/1/0500/3132/9438/files/FullSizeRender_0352553d-1c51-49f4-a4d9-8560be35b007.heic?v=1780354282",
        priceCollection: "buttercream-edit",
        priceHandles: ["buttercream-sports-bra", "buttercream-high-waits-leggings"]
      },
      {
        sourceHandle: "rose-ballet-high-waist-legging",
        fetchHandle: "rose-ballet-wrap-top",
        title: "Power Soft Set",
        url: SHOP + "/collections/ballet-rose",
        image: "https://cdn.shopify.com/s/files/1/0500/3132/9438/files/904B2375-49D4-4C37-9DFE-B7790B90EDFC.jpg?v=1779049907",
        priceCollection: "ballet-rose",
        priceHandles: ["rose-ballet-wrap-top", "rose-ballet-sports-bra"]
      }
    ];
    var FEATURED_PRODUCT_OVERRIDES = {
      "berry-mood-straight-leg-pant": {
        title: "Berry Mood Set",
        url: SHOP + "/collections/berry-mood-set",
        image: "https://cdn.shopify.com/s/files/1/0500/3132/9438/files/FEFCE5C6-2382-45AB-A00B-117CF1E60FF1.jpg?v=1778439042",
        priceCollection: "berry-mood-set"
      },
      "rose-ballet-sports-bra": {
        title: "Rose Ballet Set",
        url: SHOP + "/collections/rose-ballet-set",
        image: "https://cdn.shopify.com/s/files/1/0500/3132/9438/files/IMG-0679.png?v=1778623968",
        priceCollection: "rose-ballet-set"
      },
      "buttercream-sports-bra": {
        title: "Buttercream Set",
        url: SHOP + "/collections/buttercream-edit",
        priceCollection: "buttercream-edit"
      },
      "rose-ballet-high-waist-legging": {
        title: "Power Soft Set",
        url: SHOP + "/collections/ballet-rose",
        image: "https://cdn.shopify.com/s/files/1/0500/3132/9438/files/904B2375-49D4-4C37-9DFE-B7790B90EDFC.jpg?v=1779049907",
        priceCollection: "ballet-rose",
        priceHandles: ["rose-ballet-wrap-top", "rose-ballet-sports-bra"]
      }
    };
    var CATEGORY_SPOTLIGHT_INTRO = {
      title: "Shop Favorites",
      description: "Top-rated 22N favorites designed for comfort, shape, and everyday movement — from jackets and matching sets to wraps, leggings, and shorts.",
      shopAllUrl: SHOP + "/collections/shop-all"
    };
    var CATEGORY_SPOTLIGHT_SLOTS = [
      {
        id: "jackets",
        handle: "studio-chic-jacket",
        displayTitle: "Cloud Nine Jacket",
        url: shopProductUrl("studio-chic-jacket"),
        image: "https://cdn.shopify.com/s/files/1/0500/3132/9438/files/ACAAD6B6-3EF7-4611-8360-6954FE43A091.jpg?v=1770930258"
      },
      {
        id: "matching-sets",
        handle: "red-means-go-set",
        displayTitle: "Red Means Go Set",
        url: shopProductUrl("red-means-go-set"),
        image: "https://cdn.shopify.com/s/files/1/0500/3132/9438/files/IMG_5443_3aeb4e33-329f-4255-979a-f7b1edd5608d.jpg?v=1751656907"
      },
      {
        id: "soft-wraps",
        handle: "rose-ballet-wrap-top",
        displayTitle: "Power Soft Wrap Top",
        url: shopProductUrl("rose-ballet-wrap-top"),
        image: "https://cdn.shopify.com/s/files/1/0500/3132/9438/files/904B2375-49D4-4C37-9DFE-B7790B90EDFC.jpg?v=1779049907"
      },
      {
        id: "leggings",
        handle: "rose-ballet-high-waist-legging",
        displayTitle: "Rose Ballet Legging",
        url: shopProductUrl("rose-ballet-high-waist-legging"),
        image: "https://cdn.shopify.com/s/files/1/0500/3132/9438/files/IMG-0679.png?v=1778623968"
      },
      {
        id: "shorts",
        handle: "volt-blue-leggings",
        displayTitle: "Volt Blue Legging",
        url: shopProductUrl("volt-blue-leggings"),
        image: "https://cdn.shopify.com/s/files/1/0500/3132/9438/files/807D90CC-7AEE-4FF0-A4BF-5EB715789C11.png?v=1765565394"
      }
    ];

    function isLocalHost() {
      return location.hostname === "127.0.0.1" || location.hostname === "localhost";
    }

    function assetBase() {
      if (window.__22N_CONFIG__ && window.__22N_CONFIG__.imagesBase) {
        return String(window.__22N_CONFIG__.imagesBase).replace(/\/$/, "");
      }
      if (window.__22N_CONFIG__ && window.__22N_CONFIG__.useLocalAssets) return "/22N IMAGES";
      if (!isLocalHost()) return CDN.replace(/\/$/, "");
      return "/22N IMAGES";
    }

    function logoBase() {
      if (window.__22N_CONFIG__ && window.__22N_CONFIG__.imagesBase) {
        return String(window.__22N_CONFIG__.imagesBase).replace(/\/$/, "");
      }
      if (window.__22N_CONFIG__ && window.__22N_CONFIG__.useLocalAssets) return "/22N logo";
      if (!isLocalHost()) return CDN.replace(/\/$/, "");
      return "/22N logo";
    }

    function logoSrc() {
      if (window.__22N_CONFIG__ && window.__22N_CONFIG__.logoUrl) {
        var base = String(window.__22N_CONFIG__.logoUrl).split("?")[0];
        return base + "?v=" + encodeURIComponent(CACHE);
      }
      return logoBase() + "/22N-logo.png?v=" + encodeURIComponent(CACHE);
    }

    function videoBase() {
      if (window.__22N_CONFIG__ && window.__22N_CONFIG__.videoBase) {
        return String(window.__22N_CONFIG__.videoBase).replace(/\/$/, "");
      }
      if (window.__22N_CONFIG__ && window.__22N_CONFIG__.useLocalAssets) return "page-images/miami-dream";
      if (window.__22N_CONFIG__ && window.__22N_CONFIG__.videoBase) return window.__22N_CONFIG__.videoBase;
      if (window.__22N_CONFIG__ && window.__22N_CONFIG__.useLocalAssets) return "page-images/miami-dream";
      return "https://3-22-nation-shop.pages.dev/page-images/miami-dream";
    }

    function videoSrc(file) {
      return videoBase() + "/" + file + "?v=" + encodeURIComponent(CACHE);
    }

    function src(file) {
      return assetBase() + "/" + file + "?v=" + encodeURIComponent(CACHE);
    }

    function absUrl(url) {
      if (!url) return "";
      if (url.indexOf("//") === 0) return "https:" + url;
      return url;
    }

    function loadSlot(slot, eager) {
      var directSrc = slot.getAttribute("data-src");
      var file = slot.getAttribute("data-file");
      var imgSrc = directSrc ? absUrl(directSrc) : (file ? src(file) : "");
      if (!imgSrc) return;
      var img = new Image();
      img.alt = slot.getAttribute("data-alt") || "";
      img.decoding = "async";
      if (eager) {
        img.fetchPriority = "high";
        img.loading = "eager";
      } else {
        img.loading = "lazy";
      }
      img.onload = function () { slot.classList.add("loaded"); };
      img.onerror = function () { slot.classList.add("loaded"); };
      img.src = imgSrc;
      slot.insertBefore(img, slot.firstChild);
    }

    function applyFeaturedProducts(products) {
      var cards = document.querySelectorAll(".featured-section .product-card");
      products.slice(0, cards.length).forEach(function (product, index) {
        var card = cards[index];
        if (product.sourceHandle && card.getAttribute("data-source-handle") !== product.sourceHandle) {
          card = document.querySelector('.featured-section .product-card[data-source-handle="' + product.sourceHandle + '"]') || card;
        }
        var slot = card.querySelector(".image-slot");
        var nameEl = card.querySelector(".product-name");
        var priceEl = card.querySelector(".product-price[data-live-price], .product-price");

        if (nameEl && product.title) nameEl.textContent = product.title;
        if (priceEl && product.price) {
          priceEl.textContent = product.price;
          priceEl.setAttribute("data-price-live", "true");
        }

        if (slot && product.image) {
          var img = slot.querySelector("img");
          if (!img) {
            img = document.createElement("img");
            slot.insertBefore(img, slot.firstChild);
          }
          img.alt = product.title;
          img.decoding = "async";
          img.loading = index < 2 ? "eager" : "lazy";
          img.onload = function () { slot.classList.add("loaded"); };
          img.onerror = function () { slot.classList.add("loaded"); };
          img.src = product.image;
        }

        if (product.url) {
          var productUrl = canonicalShopUrl(product.url);
          slot.setAttribute("data-href", productUrl);
          slot.setAttribute("data-wish-title", product.title || "");
          card.onclick = function (e) {
            if (e.target.closest(".image-wish-btn")) return;
            window.location.href = productUrl;
          };
        }
      });
      if (window.refreshWishlistHearts) window.refreshWishlistHearts(document.querySelector(".featured-section"));
    }

    function fetchJson(url) {
      return fetch(url).then(function (res) {
        if (!res.ok) throw new Error("Fetch failed: " + res.status);
        return res.json();
      });
    }

    function decodeHtmlEntities(text) {
      var el = document.createElement("textarea");
      el.innerHTML = text || "";
      return el.value;
    }

    function stripHtml(html) {
      return decodeHtmlEntities((html || "").replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim());
    }

    function formatPriceCents(cents) {
      var amount = Number(cents) / 100;
      return "$" + (amount % 1 ? amount.toFixed(2) : amount.toFixed(0));
    }

    function formatPriceDollars(amount) {
      var value = Number(amount);
      return "$" + (value % 1 ? value.toFixed(2) : value.toFixed(0));
    }

    function parseCollectionHandle(url) {
      var match = (url || "").match(/\/collections\/([^/?#]+)/);
      return match ? match[1] : null;
    }

    function minVariantPriceDollars(product) {
      var prices = (product.variants || []).map(function (variant) {
        return Number(variant.price);
      });
      return prices.length ? Math.min.apply(null, prices) : 0;
    }

    function fetchCollectionSetPrice(collectionHandle, priceHandles) {
      return fetchJson(SHOP + "/collections/" + collectionHandle + "/products.json?limit=50").then(function (data) {
        var products = data.products || [];
        var picks = priceHandles && priceHandles.length
          ? priceHandles.map(function (handle) {
              return products.find(function (product) { return product.handle === handle; });
            }).filter(Boolean)
          : products.slice(0, 2);

        if (!picks.length) throw new Error("No priced products for collection " + collectionHandle);

        var total = picks.reduce(function (sum, product) {
          return sum + minVariantPriceDollars(product);
        }, 0);
        return formatPriceDollars(total);
      });
    }

    function parsePriceHandles(value) {
      if (!value) return null;
      if (Array.isArray(value)) return value;
      return String(value).split(",").map(function (part) { return part.trim(); }).filter(Boolean);
    }

    function readBackInStockSlotFromCard(card) {
      var sourceHandle = card.getAttribute("data-source-handle");
      if (!sourceHandle) return null;
      var configured = BACK_IN_STOCK_SLOTS.find(function (slot) { return slot.sourceHandle === sourceHandle; });
      var priceHandles = parsePriceHandles(card.getAttribute("data-price-handles"));
      return {
        sourceHandle: sourceHandle,
        fetchHandle: (configured && configured.fetchHandle) || FEATURED_HANDLE_OVERRIDES[sourceHandle] || sourceHandle,
        title: configured && configured.title,
        url: configured && configured.url,
        image: configured && configured.image,
        priceCollection: card.getAttribute("data-price-collection") || (configured && configured.priceCollection),
        priceHandles: priceHandles || (configured && configured.priceHandles) || null
      };
    }

    function fetchStorefrontProductDollars(handle) {
      return fetch(SHOP + "/api/2024-01/graphql.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": SHOP_STOREFRONT_TOKEN
        },
        body: JSON.stringify({
          query: "query($h:String!){product(handle:$h){priceRange{minVariantPrice{amount}}}}",
          variables: { h: handle }
        })
      }).then(function (res) {
        if (!res.ok) throw new Error("Storefront fetch failed: " + res.status);
        return res.json();
      }).then(function (payload) {
        var amount = payload && payload.data && payload.data.product &&
          payload.data.product.priceRange &&
          payload.data.product.priceRange.minVariantPrice &&
          payload.data.product.priceRange.minVariantPrice.amount;
        if (!amount) throw new Error("No live price for " + handle);
        return Number(amount);
      });
    }

    function fetchBackInStockPrice(slot) {
      var handles = slot.priceHandles;
      if (handles && handles.length) {
        return Promise.all(handles.map(fetchStorefrontProductDollars)).then(function (amounts) {
          var total = amounts.reduce(function (sum, amount) { return sum + amount; }, 0);
          return formatPriceDollars(total);
        });
      }
      return fetchStorefrontProductDollars(slot.fetchHandle).then(formatPriceDollars);
    }

    function fetchBackInStockFromShop() {
      var cards = document.querySelectorAll(".featured-section .product-card[data-source-handle]");
      var slots = cards.length
        ? Array.prototype.map.call(cards, readBackInStockSlotFromCard).filter(Boolean)
        : BACK_IN_STOCK_SLOTS.slice();

      return Promise.all(slots.map(function (slot) {
        return fetchBackInStockPrice(slot).then(function (price) {
          return Object.assign({}, slot, { price: price });
        });
      }));
    }

    function syncBackInStockPrices() {
      return fetchBackInStockFromShop()
        .then(function (products) {
          if (products && products.length) applyFeaturedProducts(products);
        });
    }

    function truncateText(text, max) {
      if (!text) return "";
      if (text.length <= max) return text;
      return text.slice(0, max).replace(/\s+\S*$/, "") + "...";
    }

    function applyCategorySpotlight(payload) {
      if (!payload) return;
      var intro = payload.intro || CATEGORY_SPOTLIGHT_INTRO;
      var titleEl = document.getElementById("category-spotlight-title");
      var leadEl = document.getElementById("category-spotlight-lead");
      var shopAllEl = document.getElementById("category-spotlight-shop-all");
      if (titleEl && intro.title) titleEl.textContent = intro.title;
      if (leadEl && intro.description) leadEl.textContent = intro.description;
      if (shopAllEl && intro.shopAllUrl) shopAllEl.href = intro.shopAllUrl;

      (payload.items || []).forEach(function (item) {
        var card = document.querySelector('.spotlight-card[data-slot="' + item.id + '"]');
        if (!card) return;

        var imageLink = card.querySelector(".spotlight-card-image-link");
        var title = card.querySelector(".spotlight-card-title");
        var desc = card.querySelector(".spotlight-card-desc");
        var price = card.querySelector(".spotlight-price");
        var compare = card.querySelector(".spotlight-compare-price");
        var shopBtn = card.querySelector(".spotlight-shop-btn");
        var slot = card.querySelector(".spotlight-card-image");

        if (title) title.textContent = item.title || "";
        if (desc) desc.textContent = truncateText(item.description || "", 140);
        if (price) price.textContent = item.price || "";
        if (compare) {
          if (item.compareAtPrice) {
            compare.textContent = item.compareAtPrice;
            compare.classList.remove("is-hidden");
          } else {
            compare.textContent = "";
            compare.classList.add("is-hidden");
          }
        }
        if (imageLink && item.url) imageLink.href = canonicalShopUrl(item.url);
        if (shopBtn && item.url) shopBtn.href = canonicalShopUrl(item.url);
        if (slot && item.url) {
          slot.setAttribute("data-href", canonicalShopUrl(item.url));
          slot.setAttribute("data-wish-title", item.title || "");
        }

        if (slot && item.image) {
          var img = slot.querySelector("img");
          if (!img) {
            img = document.createElement("img");
            slot.insertBefore(img, slot.firstChild);
          }
          img.alt = item.title || "";
          img.decoding = "async";
          img.loading = "lazy";
          img.onload = function () { slot.classList.add("loaded"); };
          img.onerror = function () { slot.classList.add("loaded"); };
          img.src = item.image;
        }
      });
      if (window.refreshWishlistHearts) window.refreshWishlistHearts(document.getElementById("category-spotlight"));
    }

    function fetchCategorySpotlightFromShop() {
      return Promise.all(CATEGORY_SPOTLIGHT_SLOTS.map(function (slot) {
        return fetchJson(SHOP + "/products/" + slot.handle + ".js").then(function (product) {
          var variant = product.variants && product.variants[0];
          var priceCents = variant ? Number(variant.price) : 0;
          var compareCents = variant && variant.compare_at_price ? Number(variant.compare_at_price) : null;
          return {
            id: slot.id,
            handle: slot.handle,
            title: slot.displayTitle || product.title,
            description: stripHtml(product.description),
            url: slot.url || shopProductUrl(product.handle),
            image: slot.image || absUrl(product.featured_image || (product.images && product.images[0])),
            price: formatPriceCents(priceCents),
            compareAtPrice: compareCents && compareCents > priceCents ? formatPriceCents(compareCents) : null
          };
        });
      })).then(function (items) {
        return { intro: CATEGORY_SPOTLIGHT_INTRO, items: items };
      });
    }

    function syncCategorySpotlight() {
      var cachedUrl = assetBase() + "/category-spotlight.json?v=" + encodeURIComponent(CACHE);
      return fetchCategorySpotlightFromShop()
        .catch(function () {
          if (false) throw new Error('skip');
          return fetchJson(window.__22N_CONFIG__.apiBase + '/api/category-spotlight');
        })
        .catch(function () {
          return fetchJson(cachedUrl);
        })
        .then(function (payload) {
          if (payload && payload.items && payload.items.length) applyCategorySpotlight(payload);
        })
        .catch(function () {});
    }

    var CUSTOMER_REVIEWS_INTRO = {
      kicker: "Verified Reviews",
      title: "What Our Customers Are Saying",
      description: "Real reviews from verified 22 natiON shop customers."
    };
    var JUDGE_ME_SHOP_DOMAIN = "hola-poison.myshopify.com";
    var customerReviewsIndex = 0;
    var customerReviewsResizeTimer = null;
    var customerReviewsAutoplayTimer = null;
    var CUSTOMER_REVIEWS_AUTOPLAY_MS = 6000;
    var CHECK_ICON_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 12.5l4 4L18 8.5"/></svg>';
    var SHIELD_ICON_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l8 3v6c0 5-3.5 8.5-8 9-4.5-.5-8-4-8-9V6l8-3z"/></svg>';

    function reviewerInitials(name) {
      var parts = String(name || "").trim().split(/\s+/).filter(Boolean);
      if (!parts.length) return "22";
      return parts.slice(0, 2).map(function (part) { return part.charAt(0).toUpperCase(); }).join("");
    }

    function renderReviewStars(rating) {
      var score = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
      var stars = "";
      for (var i = 0; i < 5; i++) stars += i < score ? "★" : "☆";
      return stars;
    }

    function defaultReviewHighlights(rating) {
      var score = Number(rating) || 5;
      if (score >= 5) return ["Premium quality", "True to size", "Would recommend"];
      if (score >= 4) return ["Great fit", "Soft fabric", "Would buy again"];
      return ["Comfortable wear", "Everyday style"];
    }

    function reviewerKey(name) {
      var normalized = String(name || "").trim().toLowerCase().replace(/\s+/g, " ");
      if (!normalized) return "verified customer";
      return normalized.split(" ")[0];
    }

    function interleaveCustomerReviews(reviews) {
      if (!reviews || reviews.length <= 1) return reviews ? reviews.slice() : [];

      var buckets = {};
      reviews.forEach(function (review) {
        var key = reviewerKey(review.name);
        if (!buckets[key]) buckets[key] = [];
        buckets[key].push(review);
      });

      var ordered = [];
      while (ordered.length < reviews.length) {
        var lastKey = ordered.length ? reviewerKey(ordered[ordered.length - 1].name) : "";
        var candidates = Object.keys(buckets).filter(function (key) {
          return buckets[key].length > 0 && key !== lastKey;
        });

        if (!candidates.length) {
          var fallbackKey = Object.keys(buckets).find(function (key) {
            return buckets[key].length > 0;
          });
          if (!fallbackKey) break;
          ordered.push(buckets[fallbackKey].shift());
          continue;
        }

        candidates.sort(function (a, b) {
          return buckets[b].length - buckets[a].length;
        });
        ordered.push(buckets[candidates[0]].shift());
      }

      return ordered;
    }

    function normalizeCustomerReview(item) {
      var handle = item.productHandle || item.handle || "";
      var productUrl = item.productUrl || (handle ? shopProductUrl(handle) : SHOP);
      return {
        id: String(item.id || item.reviewId || productUrl + (item.title || item.body || "")),
        name: item.name || item.reviewerName || "Verified customer",
        verified: item.verified !== false,
        rating: Number(item.rating) || 5,
        title: item.title || "",
        body: item.body || "",
        productTitle: item.productTitle || "",
        productUrl: productUrl,
        productImage: absUrl(item.productImage || item.image || ""),
        avatar: absUrl(item.avatar || ""),
        highlights: Array.isArray(item.highlights) && item.highlights.length
          ? item.highlights
          : defaultReviewHighlights(item.rating)
      };
    }

    function applyCustomerReviewsIntro(intro) {
      var data = intro || CUSTOMER_REVIEWS_INTRO;
      var kicker = document.getElementById("customer-reviews-kicker-text");
      var title = document.getElementById("customer-reviews-title");
      var lead = document.getElementById("customer-reviews-lead");
      if (kicker && data.kicker) kicker.textContent = data.kicker;
      if (title && data.title) title.textContent = data.title;
      if (lead && data.description) lead.textContent = data.description;
    }

    function buildCustomerReviewCard(review) {
      var card = document.createElement("article");
      card.className = "customer-review-card";
      card.setAttribute("data-review-id", review.id);

      var head = document.createElement("header");
      head.className = "customer-review-card-head";

      var reviewer = document.createElement("div");
      reviewer.className = "customer-review-reviewer";
      var avatar = document.createElement("div");
      avatar.className = "customer-review-avatar";
      if (review.avatar) {
        var avatarImg = document.createElement("img");
        avatarImg.src = review.avatar;
        avatarImg.alt = review.name;
        avatar.appendChild(avatarImg);
      } else {
        avatar.textContent = reviewerInitials(review.name);
      }
      var reviewerInfo = document.createElement("div");
      var nameEl = document.createElement("span");
      nameEl.className = "customer-review-name";
      nameEl.textContent = review.name;
      var verified = document.createElement("span");
      verified.className = "customer-review-verified";
      verified.innerHTML = CHECK_ICON_SVG + " Verified customer";
      reviewerInfo.appendChild(nameEl);
      if (review.verified) reviewerInfo.appendChild(verified);
      reviewer.appendChild(avatar);
      reviewer.appendChild(reviewerInfo);

      var meta = document.createElement("div");
      meta.className = "customer-review-meta";
      var verifiedLabel = document.createElement("strong");
      verifiedLabel.textContent = "Verified purchase";
      var verifiedValue = document.createElement("span");
      verifiedValue.className = "customer-review-meta-value";
      verifiedValue.textContent = review.verified ? "Yes" : "—";
      var ratingLabel = document.createElement("strong");
      ratingLabel.textContent = "Rating";
      var stars = document.createElement("span");
      stars.className = "customer-review-stars";
      stars.setAttribute("aria-label", review.rating + " out of 5 stars");
      stars.textContent = renderReviewStars(review.rating);
      meta.appendChild(verifiedLabel);
      meta.appendChild(verifiedValue);
      meta.appendChild(ratingLabel);
      meta.appendChild(stars);

      var product = document.createElement("div");
      product.className = "customer-review-product";
      if (review.productImage) {
        var productImg = document.createElement("img");
        productImg.src = review.productImage;
        productImg.alt = review.productTitle || "Reviewed product";
        product.appendChild(productImg);
      }
      if (review.productTitle) {
        var productLink = document.createElement("a");
        productLink.href = review.productUrl;
        productLink.textContent = review.productTitle;
        product.appendChild(productLink);
      }

      head.appendChild(reviewer);
      head.appendChild(meta);
      head.appendChild(product);

      var headline = document.createElement("h3");
      headline.className = "customer-review-headline";
      headline.textContent = review.title || (review.body ? review.body.slice(0, 90) + (review.body.length > 90 ? "..." : "") : "Customer review");

      var body = document.createElement("p");
      body.className = "customer-review-body";
      body.textContent = review.body;

      var highlights = document.createElement("div");
      highlights.className = "customer-review-highlights";
      review.highlights.forEach(function (label) {
        var tag = document.createElement("span");
        tag.className = "customer-review-highlight";
        tag.innerHTML = SHIELD_ICON_SVG + " " + label;
        highlights.appendChild(tag);
      });

      var foot = document.createElement("p");
      foot.className = "customer-review-foot";
      foot.textContent = "Reviews powered by Judge.me";

      card.appendChild(head);
      card.appendChild(headline);
      card.appendChild(body);
      card.appendChild(highlights);
      card.appendChild(foot);
      return card;
    }

    function stopCustomerReviewsAutoplay() {
      if (customerReviewsAutoplayTimer) {
        clearInterval(customerReviewsAutoplayTimer);
        customerReviewsAutoplayTimer = null;
      }
    }

    function startCustomerReviewsAutoplay() {
      stopCustomerReviewsAutoplay();
      var carousel = document.getElementById("customer-reviews-carousel");
      var track = document.getElementById("customer-reviews-track");
      if (!carousel || carousel.hidden || !track) return;
      if (track.querySelectorAll(".customer-review-card").length <= 1) return;
      customerReviewsAutoplayTimer = setInterval(function () {
        var cards = track.querySelectorAll(".customer-review-card");
        if (!cards.length) return;
        customerReviewsIndex = (customerReviewsIndex + 1) % cards.length;
        updateCustomerReviewsCarousel();
      }, CUSTOMER_REVIEWS_AUTOPLAY_MS);
    }

    function resetCustomerReviewsAutoplay() {
      stopCustomerReviewsAutoplay();
      startCustomerReviewsAutoplay();
    }

    function layoutCustomerReviewsCarousel() {
      var viewport = document.getElementById("customer-reviews-viewport");
      var track = document.getElementById("customer-reviews-track");
      if (!viewport || !track) return 0;

      var viewportWidth = viewport.clientWidth;
      if (!viewportWidth) return 0;

      var cardRatio = window.matchMedia("(max-width: 768px)").matches ? 0.9 : 0.86;
      var cardWidth = Math.min(720, Math.round(viewportWidth * cardRatio));
      var sidePadding = Math.max(0, Math.round((viewportWidth - cardWidth) / 2));

      track.style.paddingLeft = sidePadding + "px";
      track.style.paddingRight = sidePadding + "px";
      track.querySelectorAll(".customer-review-card").forEach(function (card) {
        card.style.flexBasis = cardWidth + "px";
        card.style.maxWidth = cardWidth + "px";
      });

      return cardWidth;
    }

    function updateCustomerReviewsCarousel() {
      var track = document.getElementById("customer-reviews-track");
      var viewport = document.getElementById("customer-reviews-viewport");
      var dots = document.getElementById("customer-reviews-dots");
      var prev = document.getElementById("customer-reviews-prev");
      var next = document.getElementById("customer-reviews-next");
      if (!track || !viewport) return;

      layoutCustomerReviewsCarousel();

      var cards = track.querySelectorAll(".customer-review-card");
      if (!cards.length) return;

      if (customerReviewsIndex < 0) customerReviewsIndex = 0;
      if (customerReviewsIndex >= cards.length) customerReviewsIndex = cards.length - 1;

      cards.forEach(function (card, index) {
        card.classList.toggle("is-active", index === customerReviewsIndex);
      });

      var active = cards[customerReviewsIndex];
      var viewportWidth = viewport.clientWidth;
      var scroll = active.offsetLeft + active.offsetWidth / 2 - viewportWidth / 2;
      var maxScroll = Math.max(0, track.scrollWidth - viewportWidth);
      scroll = Math.max(0, Math.min(maxScroll, scroll));
      track.style.transform = "translateX(" + (-scroll) + "px)";

      if (dots) {
        dots.querySelectorAll(".customer-reviews-dot").forEach(function (dot, index) {
          dot.classList.toggle("is-active", index === customerReviewsIndex);
          dot.setAttribute("aria-current", index === customerReviewsIndex ? "true" : "false");
        });
      }

      if (prev) prev.disabled = customerReviewsIndex <= 0;
      if (next) next.disabled = customerReviewsIndex >= cards.length - 1;
    }

    function bindCustomerReviewsCarousel(count) {
      var prev = document.getElementById("customer-reviews-prev");
      var next = document.getElementById("customer-reviews-next");
      var dots = document.getElementById("customer-reviews-dots");

      if (dots) {
        dots.innerHTML = "";
        for (var i = 0; i < count; i++) {
          var li = document.createElement("li");
          var dot = document.createElement("button");
          dot.type = "button";
          dot.className = "customer-reviews-dot" + (i === 0 ? " is-active" : "");
          dot.setAttribute("aria-label", "Go to review " + (i + 1));
          dot.setAttribute("aria-current", i === 0 ? "true" : "false");
          (function (index) {
            dot.addEventListener("click", function () {
              customerReviewsIndex = index;
              updateCustomerReviewsCarousel();
              resetCustomerReviewsAutoplay();
            });
          })(i);
          li.appendChild(dot);
          dots.appendChild(li);
        }
      }

      if (prev && !prev.dataset.bound) {
        prev.dataset.bound = "1";
        prev.addEventListener("click", function () {
          customerReviewsIndex -= 1;
          updateCustomerReviewsCarousel();
          resetCustomerReviewsAutoplay();
        });
      }

      if (next && !next.dataset.bound) {
        next.dataset.bound = "1";
        next.addEventListener("click", function () {
          customerReviewsIndex += 1;
          updateCustomerReviewsCarousel();
          resetCustomerReviewsAutoplay();
        });
      }

      var section = document.getElementById("customer-reviews-section");
      if (section && !section.dataset.autoplayBound) {
        section.dataset.autoplayBound = "1";
        section.addEventListener("mouseenter", stopCustomerReviewsAutoplay);
        section.addEventListener("mouseleave", startCustomerReviewsAutoplay);
        section.addEventListener("focusin", stopCustomerReviewsAutoplay);
        section.addEventListener("focusout", startCustomerReviewsAutoplay);
      }

      if (!window.customerReviewsResizeBound) {
        window.customerReviewsResizeBound = true;
        window.addEventListener("resize", function () {
          clearTimeout(customerReviewsResizeTimer);
          customerReviewsResizeTimer = setTimeout(updateCustomerReviewsCarousel, 120);
        });
      }
    }

    function applyCustomerReviews(payload) {
      var reviews = interleaveCustomerReviews(
        (payload && payload.reviews ? payload.reviews : []).map(normalizeCustomerReview)
      );
      var carousel = document.getElementById("customer-reviews-carousel");
      var track = document.getElementById("customer-reviews-track");
      var empty = document.getElementById("customer-reviews-empty");

      applyCustomerReviewsIntro(payload && payload.intro);

      if (!track || !carousel || !empty) return;

      track.innerHTML = "";
      customerReviewsIndex = 0;

      if (!reviews.length) {
        carousel.hidden = true;
        empty.hidden = false;
        return;
      }

      reviews.forEach(function (review) {
        track.appendChild(buildCustomerReviewCard(review));
      });

      empty.hidden = true;
      carousel.hidden = false;
      bindCustomerReviewsCarousel(reviews.length);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          updateCustomerReviewsCarousel();
          startCustomerReviewsAutoplay();
        });
      });
    }

    function syncCustomerReviews() {
      var cachedUrl = assetBase() + "/customer-reviews.json?v=" + encodeURIComponent(CACHE);
      return fetchJson(window.__22N_CONFIG__.apiBase + '/api/customer-reviews')
        .catch(function () {
          return fetchJson(cachedUrl);
        })
        .then(function (payload) {
          applyCustomerReviews(payload);
        })
        .catch(function () {
          applyCustomerReviews({ intro: CUSTOMER_REVIEWS_INTRO, reviews: [] });
        });
    }

    function fetchFeaturedFromShop() {
      return fetchJson(SHOP + "/?sections=" + FEATURED_SECTIONS.join(",")).then(function (sections) {
        var sourceHandles = FEATURED_SECTIONS.map(function (sectionId) {
          var html = sections[sectionId] || "";
          var match = html.match(/\/products\/([^"'?#]+)/);
          return match ? match[1] : null;
        }).filter(Boolean);

        return Promise.all(sourceHandles.map(function (sourceHandle) {
          var fetchHandle = FEATURED_HANDLE_OVERRIDES[sourceHandle] || sourceHandle;
          return fetchJson(SHOP + "/products/" + fetchHandle + ".js").then(function (product) {
            var variant = product.variants && product.variants[0];
            var result = {
              handle: product.handle,
              title: product.title,
              url: shopProductUrl(product.handle),
              image: absUrl(product.featured_image || (product.images && product.images[0])),
              price: variant ? formatPriceCents(variant.price) : ""
            };
            var override = FEATURED_PRODUCT_OVERRIDES[sourceHandle];
            var merged = override ? Object.assign({}, result, override) : result;
            var collectionHandle = (override && override.priceCollection) || parseCollectionHandle(override && override.url);

            if (!collectionHandle) return merged;

            return fetchCollectionSetPrice(collectionHandle, override && override.priceHandles).then(function (price) {
              merged.price = price;
              return merged;
            });
          });
        }));
      });
    }

    function syncFeaturedProducts() {
      var cachedUrl = assetBase() + "/featured-products.json?v=" + encodeURIComponent(CACHE);
      var liveUrl = "/api/featured-products";

      return syncBackInStockPrices()
        .catch(function () {
          return fetchFeaturedFromShop()
            .then(function (products) {
              if (products && products.length) applyFeaturedProducts(products);
            });
        })
        .catch(function () {
          return fetchJson(liveUrl).then(function (payload) {
            if (payload && payload.products && payload.products.length) applyFeaturedProducts(payload.products);
          });
        })
        .catch(function () {
          return fetchJson(cachedUrl).then(function (payload) {
            if (payload && payload.products && payload.products.length) applyFeaturedProducts(payload.products);
          });
        })
        .catch(function () {
          document.querySelectorAll(".featured-section [data-file]").forEach(function (slot) {
            if (!slot.classList.contains("loaded")) loadSlot(slot, false);
          });
        });
    }

    var slots = document.querySelectorAll("[data-file], [data-src]");
    for (var i = 0; i < slots.length; i++) {
      loadSlot(slots[i], i < 3);
    }

    syncFeaturedProducts();
    syncCategorySpotlight();
    syncCustomerReviews();
    syncThemeColors();

    function parseThemeColors(announcementHtml, themeCss) {
      var bgMatch = announcementHtml.match(/\.announcement-bar\s*\{[^}]*background-color:\s*(#[0-9a-fA-F]{3,8})/i);
      var textMatch = announcementHtml.match(/\.announcement-bar__message\s*\{[^}]*color:\s*(#[0-9a-fA-F]{3,8})/i);
      var headerBg = null;
      var innerRules = themeCss.match(/\.site-header__inner\{([^}]+)\}/g) || [];

      for (var i = 0; i < innerRules.length; i++) {
        var body = innerRules[i].slice(innerRules[i].indexOf("{") + 1, -1);
        var innerBg = body.match(/background-color:\s*(#[0-9a-fA-F]{3,8})/i);
        if (innerBg && innerBg[1].toLowerCase() !== "transparent") {
          headerBg = innerBg[1];
          break;
        }
      }

      if (!headerBg) {
        var headerRule = themeCss.match(/header\{height:65px;background:([^;}\s]+)/i);
        if (headerRule) headerBg = headerRule[1];
      }

      var headerTextMatch = themeCss.match(/\.site-header__link\{[^}]*color:\s*(#[0-9a-fA-F]{3,8})/i);
      var headerText = headerTextMatch ? headerTextMatch[1] : null;

      return {
        announcementBg: bgMatch ? bgMatch[1] : headerBg,
        announcementText: textMatch ? textMatch[1] : headerText,
        headerBg: headerBg
      };
    }

    function applyThemeColors(colors) {
      if (!colors) return;
      var root = document.documentElement.style;
      if (colors.announcementBg) root.setProperty("--shop-announcement-bg", colors.announcementBg);
      if (colors.headerBg) root.setProperty("--header-solid-bg", colors.headerBg);
    }

    function fetchThemeColorsFromShop() {
      return fetchJson(SHOP_COLOR_PAGE + "?sections=announcement-bar").then(function (sections) {
        var announcementHtml = sections["announcement-bar"] || "";
        return fetch(SHOP_COLOR_PAGE).then(function (res) {
          if (!res.ok) throw new Error("Shop-all page fetch failed");
          return res.text();
        }).then(function (pageHtml) {
          var cssMatch = pageHtml.match(/href="(\/\/22nationshop\.com\/cdn\/shop\/t\/\d+\/assets\/theme\.scss\.css[^"]*)"/i);
          if (!cssMatch) throw new Error("Theme CSS URL not found");
          return fetch(absUrl(cssMatch[1])).then(function (cssRes) {
            if (!cssRes.ok) throw new Error("Theme CSS fetch failed");
            return cssRes.text();
          }).then(function (themeCss) {
            return parseThemeColors(announcementHtml, themeCss);
          });
        });
      });
    }

    function syncThemeColors() {
      return fetchThemeColorsFromShop()
        .catch(function () {
          if (false) throw new Error('skip');
          return fetchJson(window.__22N_CONFIG__.apiBase + '/api/theme-colors');
        })
        .then(function (colors) {
          applyThemeColors(colors);
        })
        .catch(function () {});
    }

    (function initTopPicksReveal() {
      var stage = document.getElementById("top-picks-stage");
      if (!stage) return;
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        stage.classList.add("is-revealed");
        return;
      }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          stage.classList.add("is-revealed");
          observer.disconnect();
        });
      }, { threshold: 0.32, rootMargin: "0px 0px -8% 0px" });
      observer.observe(stage);
    })();

    (function initTopPicksLeftCarousel() {
      var carousel = document.getElementById("top-picks-left-carousel");
      var stage = document.getElementById("top-picks-stage");
      var section = document.getElementById("top-picks-section");
      if (!carousel || !stage || !section) return;

      var slides = carousel.querySelectorAll(".top-picks-left-slide");
      if (slides.length < 2) return;

      var index = 0;
      var timer = null;
      var started = false;
      var INTERVAL_MS = 3000;
      var SLIDE_MS = 1150;

      function showSlide(next) {
        if (next === index) return;
        var prev = slides[index];
        var nextEl = slides[next];
        nextEl.classList.remove("is-active", "is-exiting");
        nextEl.style.transition = "none";
        void nextEl.offsetWidth;
        nextEl.style.transition = "";
        prev.classList.remove("is-active");
        prev.classList.add("is-exiting");
        nextEl.classList.add("is-active");
        stage.classList.add("is-left-sliding");
        setTimeout(function () {
          prev.classList.remove("is-exiting");
          stage.classList.remove("is-left-sliding");
        }, SLIDE_MS);
        index = next;
      }

      function nextSlide() {
        showSlide((index + 1) % slides.length);
        timer = setTimeout(nextSlide, INTERVAL_MS);
      }

      function start() {
        if (started || timer || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        started = true;
        timer = setTimeout(nextSlide, INTERVAL_MS);
      }

      function stop() {
        if (!timer) return;
        clearTimeout(timer);
        timer = null;
        started = false;
      }

      function waitForReveal() {
        if (stage.classList.contains("is-revealed")) {
          start();
          return;
        }
        var revealObserver = new MutationObserver(function () {
          if (!stage.classList.contains("is-revealed")) return;
          revealObserver.disconnect();
          setTimeout(start, SLIDE_MS);
        });
        revealObserver.observe(stage, { attributes: true, attributeFilter: ["class"] });
      }

      var sectionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) waitForReveal();
          else stop();
        });
      }, { threshold: 0.2 });
      sectionObserver.observe(section);
    })();

    (function initTopPicksCarousel() {
      var carousel = document.getElementById("top-picks-carousel");
      var section = document.getElementById("top-picks-section");
      var stage = document.getElementById("top-picks-stage");
      if (!carousel || !section || !stage) return;

      var slides = carousel.querySelectorAll(".top-picks-carousel-slide");
      if (slides.length < 2) return;

      var index = 0;
      var timer = null;
      var INTERVAL_MS = 3000;
      var SLIDE_MS = 1150;

      function showSlide(next) {
        if (next === index) return;
        var prev = slides[index];
        var nextEl = slides[next];
        nextEl.classList.remove("is-active", "is-exiting");
        nextEl.style.transition = "none";
        void nextEl.offsetWidth;
        nextEl.style.transition = "";
        prev.classList.remove("is-active");
        prev.classList.add("is-exiting");
        nextEl.classList.add("is-active");
        stage.classList.add("is-right-sliding");
        setTimeout(function () {
          prev.classList.remove("is-exiting");
          stage.classList.remove("is-right-sliding");
        }, SLIDE_MS);
        index = next;
      }

      function nextSlide() {
        showSlide((index + 1) % slides.length);
        timer = setTimeout(nextSlide, INTERVAL_MS);
      }

      function start() {
        if (timer || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        timer = setTimeout(nextSlide, INTERVAL_MS);
      }

      function stop() {
        if (!timer) return;
        clearTimeout(timer);
        timer = null;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) start();
          else stop();
        });
      }, { threshold: 0.2 });
      observer.observe(section);
    })();

    (function initHeroVideo() {
      var videoSection = document.getElementById("hero-video-section");
      var desktopVideo = document.getElementById("hero-video-desktop");
      var mobileVideo = document.getElementById("hero-video-mobile");
      var headerEl = document.getElementById("site-header");
      if (!videoSection || !desktopVideo || !mobileVideo) return;

      desktopVideo.src = videoSrc("miami-dreams-vid-169.mp4");
      mobileVideo.src = videoSrc("miami-dream-vid-01.mp4");

      var started = false;
      var bumpLocked = false;
      var bumpReleased = false;
      var bumpScrollY = 0;
      var bumpTimer = null;
      var BUMP_HOLD_MS = 1000;
      var mobileQuery = window.matchMedia("(max-width: 768px)");

      function activeVideo() {
        return mobileQuery.matches ? mobileVideo : desktopVideo;
      }

      function pauseAll() {
        desktopVideo.pause();
        mobileVideo.pause();
      }

      function resetVideos() {
        pauseAll();
        desktopVideo.currentTime = 0;
        mobileVideo.currentTime = 0;
      }

      function resetExperience() {
        clearTimeout(bumpTimer);
        bumpTimer = null;
        started = false;
        bumpLocked = false;
        bumpReleased = false;
        bumpScrollY = 0;
        document.body.classList.remove("is-video-bump-stop");
        window.removeEventListener("wheel", preventScroll);
        window.removeEventListener("touchmove", preventScroll);
        resetVideos();
        window.scrollTo(0, 0);
      }

      function getVideoBumpAnchor() {
        if (document.body.classList.contains("mobile-landing")) {
          var ann = document.querySelector(".announcement-bar");
          return ann ? ann.offsetHeight : 40;
        }
        return headerEl ? headerEl.offsetHeight : 0;
      }

      function getBumpScrollTarget() {
        return window.scrollY + videoSection.getBoundingClientRect().top - getVideoBumpAnchor();
      }

      function preventScroll(e) {
        if (bumpLocked) e.preventDefault();
      }

      function startVideo() {
        if (started) return;
        started = true;
        pauseAll();
        var playPromise = activeVideo().play();
        if (playPromise && playPromise.catch) playPromise.catch(function () {});
      }

      function maybeStartVideo() {
        if (started) return;
        var maxScroll = document.documentElement.scrollHeight - window.innerHeight;
        if (maxScroll <= 0) return;
        if (window.scrollY / maxScroll >= 0.2) startVideo();
      }

      function lockBumpStop() {
        if (bumpReleased || bumpLocked) return;
        bumpLocked = true;
        bumpScrollY = Math.max(0, getBumpScrollTarget());
        document.body.classList.add("is-video-bump-stop");
        window.addEventListener("wheel", preventScroll, { passive: false });
        window.addEventListener("touchmove", preventScroll, { passive: false });
        window.scrollTo(0, bumpScrollY);
        startVideo();
        bumpTimer = setTimeout(function () {
          bumpLocked = false;
          bumpReleased = true;
          document.body.classList.remove("is-video-bump-stop");
          window.removeEventListener("wheel", preventScroll);
          window.removeEventListener("touchmove", preventScroll);
        }, BUMP_HOLD_MS);
      }

      function enforceBumpLock() {
        if (!bumpLocked) return;
        if (Math.abs(window.scrollY - bumpScrollY) > 1) {
          window.scrollTo(0, bumpScrollY);
        }
      }

      function onHeroVideoScroll() {
        maybeStartVideo();
        if (!bumpReleased && !bumpLocked) {
          if (videoSection.getBoundingClientRect().top <= getVideoBumpAnchor() + 1) {
            lockBumpStop();
          }
        }
        enforceBumpLock();
      }

      if ("scrollRestoration" in history) history.scrollRestoration = "manual";
      resetExperience();

      if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener("change", function () {
          if (!started) return;
          pauseAll();
          var playPromise = activeVideo().play();
          if (playPromise && playPromise.catch) playPromise.catch(function () {});
        });
      }

      window.addEventListener("scroll", onHeroVideoScroll, { passive: true });
      window.addEventListener("resize", function () {
        if (bumpLocked) {
          bumpScrollY = Math.max(0, getBumpScrollTarget());
          window.scrollTo(0, bumpScrollY);
        }
      });
      window.addEventListener("pageshow", function (e) {
        if (e.persisted) resetExperience();
      });
    })();

    var siteHeader = document.getElementById("site-header");
    var heroSection = document.querySelector(".hero-section[data-transparent-over-me]");
    function updateHeaderState() {
      if (!siteHeader) return;
      // Storefront (no hero): transparent at top; pink when scrolled (desktop web only).
      if (!heroSection) {
        var isStorefrontDesktop =
          document.body.classList.contains("n22-new-header-active") && window.innerWidth >= 769;
        if (isStorefrontDesktop) {
          siteHeader.classList.toggle("is-scrolled", window.scrollY > 12);
          siteHeader.classList.remove("is-solid");
        } else {
          siteHeader.classList.remove("is-scrolled");
          siteHeader.classList.remove("is-solid");
        }
        return;
      }
      if (document.body.classList.contains("mobile-landing")) {
        siteHeader.classList.remove("is-solid");
        return;
      }
      var threshold = heroSection.offsetHeight - siteHeader.offsetHeight - 24;
      siteHeader.classList.toggle("is-solid", window.scrollY > threshold);
    }
    updateHeaderState();
    window.addEventListener("scroll", updateHeaderState, { passive: true });
    window.addEventListener("resize", updateHeaderState, { passive: true });

    (function initMobileNavDrawer() {
      var toggle = document.getElementById("mobile-nav-toggle");
      var drawer = document.getElementById("mobile-nav-drawer");
      var primary = document.getElementById("mobile-nav-drawer-primary");
      var sub = document.getElementById("mobile-nav-drawer-sub");
      var drawerIcons = document.getElementById("mobile-nav-drawer-icons");
      var mobileHeaderActions = document.getElementById("mobile-header-actions");
      var navRight = document.querySelector(".nav-right");
      var navRightIcons = document.querySelector(".nav-right-icons");
      var fitmatchIcon = navRightIcons && navRightIcons.querySelector('[data-mega-target="fitmatch"]');
      var cartWrap = document.getElementById("nav-cart");
      var navSearch = document.getElementById("nav-search");
      var populated = false;

      function syncNavIconsPlacement() {
        if (!navRight || !navRightIcons) return;
        if (document.body.classList.contains("mobile-landing")) {
          if (mobileHeaderActions) {
            if (fitmatchIcon && fitmatchIcon.parentElement !== mobileHeaderActions) {
              mobileHeaderActions.appendChild(fitmatchIcon);
            }
            if (cartWrap && cartWrap.parentElement !== mobileHeaderActions) {
              mobileHeaderActions.appendChild(cartWrap);
            }
          }
          if (drawerIcons && navRightIcons.parentElement !== drawerIcons) {
            drawerIcons.appendChild(navRightIcons);
          }
        } else {
          if (navRightIcons.parentElement !== navRight) {
            navRight.appendChild(navRightIcons);
          }
          if (fitmatchIcon && fitmatchIcon.parentElement !== navRightIcons) {
            if (navSearch && navSearch.parentElement === navRightIcons) {
              navRightIcons.insertBefore(fitmatchIcon, navSearch.nextElementSibling);
            } else {
              navRightIcons.insertBefore(fitmatchIcon, navRightIcons.firstChild);
            }
          }
          if (cartWrap && cartWrap.parentElement !== navRightIcons) {
            navRightIcons.appendChild(cartWrap);
          }
        }
      }

      function populateDrawer() {
        if (populated || !primary || !sub) return;
        var navLeft = document.querySelector(".nav-left ul");
        var subNav = document.querySelector(".sub-nav ul");
        if (navLeft) {
          navLeft.querySelectorAll("li").forEach(function (li) {
            primary.appendChild(li.cloneNode(true));
          });
        }
        if (subNav) {
          subNav.querySelectorAll("li").forEach(function (li) {
            sub.appendChild(li.cloneNode(true));
          });
        }
        populated = true;
      }

      function setMobileNavOpen(isOpen) {
        if (!document.body.classList.contains("mobile-landing")) {
          isOpen = false;
        }
        document.body.classList.toggle("is-mobile-nav-open", isOpen);
        if (siteHeader) siteHeader.classList.toggle("is-mobile-nav-open", isOpen);
        if (toggle) toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
        if (drawer) drawer.hidden = !isOpen;
        if (isOpen) {
          if (window.closeHeaderSearch) window.closeHeaderSearch();
          if (window.closeWishlistDropdown) window.closeWishlistDropdown();
          if (window.closeSocialDropdown) window.closeSocialDropdown();
          if (window.closeCartPreview) window.closeCartPreview();
          if (window.closeMegaMenus) window.closeMegaMenus();
        }
      }

      window.closeMobileNav = function () {
        setMobileNavOpen(false);
      };

      if (toggle) {
        toggle.addEventListener("click", function (e) {
          e.stopPropagation();
          syncNavIconsPlacement();
          populateDrawer();
          setMobileNavOpen(!document.body.classList.contains("is-mobile-nav-open"));
        });
      }

      document.addEventListener("click", function (e) {
        if (!document.body.classList.contains("is-mobile-nav-open")) return;
        if (drawer && toggle && !drawer.contains(e.target) && !toggle.contains(e.target)) {
          setMobileNavOpen(false);
        }
      });

      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") setMobileNavOpen(false);
      });

      var mobileMq = window.matchMedia("(max-width: 768px)");
      function syncMobileNavMode() {
        syncNavIconsPlacement();
        if (!mobileMq.matches) setMobileNavOpen(false);
      }
      syncMobileNavMode();
      if (mobileMq.addEventListener) mobileMq.addEventListener("change", syncMobileNavMode);
      else if (mobileMq.addListener) mobileMq.addListener(syncMobileNavMode);
    })();

    (function initMobileFooterPillars() {
      var footer = document.querySelector(".main-footer");
      if (!footer) return;
      var toggles = footer.querySelectorAll(".footer-pillar-toggle");
      var panels = footer.querySelectorAll(".footer-pillar-panel");
      var mobileMq = window.matchMedia("(max-width: 768px)");

      function syncFooterPillarMode() {
        var isMobile = mobileMq.matches;
        toggles.forEach(function (btn) {
          if (!isMobile) btn.setAttribute("aria-expanded", "true");
        });
        panels.forEach(function (panel) {
          if (!isMobile) {
            panel.hidden = false;
            return;
          }
          var col = panel.closest(".footer-col");
          var btn = col && col.querySelector(".footer-pillar-toggle");
          panel.hidden = !btn || btn.getAttribute("aria-expanded") !== "true";
        });
      }

      toggles.forEach(function (btn) {
        btn.setAttribute("aria-expanded", "false");
        btn.addEventListener("click", function () {
          if (!mobileMq.matches) return;
          var col = btn.closest(".footer-col");
          var panel = col && col.querySelector(".footer-pillar-panel");
          if (!panel) return;
          var open = btn.getAttribute("aria-expanded") === "true";
          btn.setAttribute("aria-expanded", open ? "false" : "true");
          panel.hidden = open;
        });
      });

      syncFooterPillarMode();
      if (mobileMq.addEventListener) mobileMq.addEventListener("change", syncFooterPillarMode);
      else if (mobileMq.addListener) mobileMq.addListener(syncFooterPillarMode);
    })();

    (function initMegaMenus() {
      var navZone = document.getElementById("header-nav-zone");
      var megaPanelsWrap = document.getElementById("nav-mega-panels");
      var triggers = siteHeader.querySelectorAll("[data-mega-target]");
      var panels = siteHeader.querySelectorAll(".nav-mega");
      var closeTimer;

      function openMega(panelId) {
        clearTimeout(closeTimer);
        if (window.closeHeaderSearch) window.closeHeaderSearch();
        if (window.closeWishlistDropdown) window.closeWishlistDropdown();
        if (window.closeSocialDropdown) window.closeSocialDropdown();
        if (window.closeCartPreview) window.closeCartPreview();
        siteHeader.classList.add("is-mega-open");
        if (megaPanelsWrap) megaPanelsWrap.classList.add("is-active");
        panels.forEach(function (panel) {
          panel.classList.toggle("is-active", panel.getAttribute("data-panel") === panelId);
        });
      }

      function closeMega() {
        closeTimer = setTimeout(function () {
          closeMegaNow();
        }, 140);
      }

      function closeMegaNow() {
        clearTimeout(closeTimer);
        siteHeader.classList.remove("is-mega-open");
        if (megaPanelsWrap) megaPanelsWrap.classList.remove("is-active");
        panels.forEach(function (panel) { panel.classList.remove("is-active"); });
      }

      triggers.forEach(function (trigger) {
        trigger.addEventListener("mouseenter", function () {
          if (document.body.classList.contains("mobile-landing")) return;
          openMega(trigger.getAttribute("data-mega-target"));
        });
        trigger.addEventListener("click", function (e) {
          e.preventDefault();
          if (document.body.classList.contains("mobile-landing")) {
            openMega(trigger.getAttribute("data-mega-target"));
            if (window.closeMobileNav) window.closeMobileNav();
          }
        });
      });

      var mobileDrawer = document.getElementById("mobile-nav-drawer");
      if (mobileDrawer) {
        mobileDrawer.addEventListener("click", function (e) {
          var megaLink = e.target.closest("[data-mega-target]");
          if (megaLink) {
            e.preventDefault();
            openMega(megaLink.getAttribute("data-mega-target"));
            if (window.closeMobileNav) window.closeMobileNav();
            return;
          }
          var link = e.target.closest("a[href]");
          if (link && link.getAttribute("href") !== "#" && window.closeMobileNav) {
            window.closeMobileNav();
          }
        });
      }

      if (navZone) {
        navZone.addEventListener("mouseleave", function (e) {
          if (!navZone.contains(e.relatedTarget)) closeMega();
        });
      }

      window.openFitMatchMega = function () {
        openMega("fitmatch");
        window.scrollTo({ top: 0, behavior: "smooth" });
      };

      window.closeMegaMenus = closeMega;

      var fitmatchMobileClose = document.getElementById("fitmatch-mobile-close");
      if (fitmatchMobileClose) {
        fitmatchMobileClose.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          closeMegaNow();
        });
      }

      (function initHeaderSearch() {
        var searchWrap = document.getElementById("nav-search");
        var searchTrigger = document.getElementById("nav-search-trigger");
        var searchDropdown = document.getElementById("nav-search-dropdown");
        var searchForm = document.getElementById("nav-search-form");
        var searchInput = document.getElementById("nav-search-input");
        var suggestList = document.getElementById("nav-search-suggest");
        if (!searchWrap || !searchTrigger || !searchDropdown || !searchForm || !searchInput) return;

        var suggestTimer = null;
        var suggestRequest = 0;

        function setSearchOpen(isOpen) {
          searchWrap.classList.toggle("is-open", isOpen);
          searchTrigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
          searchDropdown.hidden = !isOpen;
          if (isOpen) {
            closeMega();
            if (window.closeWishlistDropdown) window.closeWishlistDropdown();
            if (window.closeSocialDropdown) window.closeSocialDropdown();
            if (window.closeCartPreview) window.closeCartPreview();
            setTimeout(function () { searchInput.focus(); }, 0);
          } else if (suggestList) {
            suggestList.innerHTML = "";
          }
        }

        function closeSearch() {
          setSearchOpen(false);
        }

        function renderSuggestions(products) {
          if (!suggestList) return;
          suggestList.innerHTML = "";
          if (!products || !products.length) return;

          products.slice(0, 5).forEach(function (product) {
            var li = document.createElement("li");
            var link = document.createElement("a");
            link.href = SHOP + product.url;
            if (product.image) {
              var img = document.createElement("img");
              img.src = product.image;
              img.alt = product.title || "";
              link.appendChild(img);
            }
            var copy = document.createElement("span");
            var title = document.createElement("span");
            title.className = "nav-search-suggest-title";
            title.textContent = product.title || "";
            copy.appendChild(title);
            if (product.price) {
              var price = document.createElement("span");
              price.className = "nav-search-suggest-price";
              price.textContent = "$" + String(product.price).replace(/\.00$/, "");
              copy.appendChild(price);
            }
            link.appendChild(copy);
            li.appendChild(link);
            suggestList.appendChild(li);
          });
        }

        function fetchSuggestions(query) {
          if (!suggestList || query.length < 2) {
            if (suggestList) suggestList.innerHTML = "";
            return;
          }

          var requestId = ++suggestRequest;
          var url = SHOP + "/search/suggest.json?q=" + encodeURIComponent(query)
            + "&resources%5Btype%5D=product&resources%5Blimit%5D=5";

          fetch(url)
            .then(function (res) {
              if (!res.ok) throw new Error("Suggest failed");
              return res.json();
            })
            .then(function (data) {
              if (requestId !== suggestRequest) return;
              var products = data && data.resources && data.resources.results && data.resources.results.products;
              renderSuggestions(products || []);
            })
            .catch(function () {
              if (requestId !== suggestRequest) return;
              suggestList.innerHTML = "";
            });
        }

        searchTrigger.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          setSearchOpen(!searchWrap.classList.contains("is-open"));
        });

        searchInput.addEventListener("input", function () {
          clearTimeout(suggestTimer);
          var query = searchInput.value.trim();
          suggestTimer = setTimeout(function () {
            fetchSuggestions(query);
          }, 220);
        });

        searchForm.addEventListener("submit", function (e) {
          var query = searchInput.value.trim();
          if (!query) {
            e.preventDefault();
            return;
          }
          searchForm.action = SHOP + "/search";
        });

        window.closeHeaderSearch = closeSearch;

        document.addEventListener("click", function (e) {
          if (!searchWrap.contains(e.target)) closeSearch();
        });

        document.addEventListener("keydown", function (e) {
          if (e.key === "Escape") closeSearch();
        });
      })();

      (function initHeaderSocial() {
        var socialWrap = document.getElementById("nav-social");
        var socialTrigger = document.getElementById("nav-social-trigger");
        var socialDropdown = document.getElementById("nav-social-dropdown");
        if (!socialWrap || !socialTrigger || !socialDropdown) return;

        function setSocialOpen(isOpen) {
          socialWrap.classList.toggle("is-open", isOpen);
          socialTrigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
          socialDropdown.hidden = !isOpen;
          if (isOpen) {
            if (window.closeMegaMenus) window.closeMegaMenus();
            if (window.closeHeaderSearch) window.closeHeaderSearch();
            if (window.closeWishlistDropdown) window.closeWishlistDropdown();
            if (window.closeCartPreview) window.closeCartPreview();
          }
        }

        function closeSocialDropdown() {
          setSocialOpen(false);
        }

        window.closeSocialDropdown = closeSocialDropdown;

        socialTrigger.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          setSocialOpen(!socialWrap.classList.contains("is-open"));
        });

        document.addEventListener("click", function (e) {
          if (!socialWrap.classList.contains("is-open")) return;
          if (!socialWrap.contains(e.target)) closeSocialDropdown();
        });

        document.addEventListener("keydown", function (e) {
          if (e.key === "Escape") closeSocialDropdown();
        });
      })();

      (function initHeaderCart() {
        var cartWrap = document.getElementById("nav-cart");
        var cartTrigger = document.getElementById("nav-cart-trigger");
        var cartDropdown = document.getElementById("nav-cart-dropdown");
        var cartEmpty = document.getElementById("nav-cart-empty");
        var cartList = document.getElementById("nav-cart-list");
        var cartMore = document.getElementById("nav-cart-more");
        var cartFooter = document.getElementById("nav-cart-footer");
        var cartSubtotal = document.getElementById("nav-cart-subtotal");
        var cartCount = document.getElementById("nav-cart-count");
        if (!cartWrap || !cartTrigger || !cartDropdown) return;

        var closeTimer = null;
        var cartRequest = 0;
        var PREVIEW_LIMIT = 4;

        function formatShopMoney(cents) {
          return "$" + (cents / 100).toFixed(2).replace(/\.00$/, "");
        }

        function updateCartCount(count) {
          if (!cartCount) return;
          if (!count) {
            cartCount.hidden = true;
            cartCount.textContent = "0";
            return;
          }
          cartCount.hidden = false;
          cartCount.textContent = count > 9 ? "9+" : String(count);
        }

        function renderCartPreview(cart) {
          if (!cartList || !cartEmpty || !cartFooter || !cartSubtotal || !cartMore) return;

          cartList.innerHTML = "";
          var items = cart && cart.items ? cart.items : [];
          var itemCount = cart && cart.item_count ? cart.item_count : 0;
          updateCartCount(itemCount);

          if (!itemCount) {
            cartEmpty.hidden = false;
            cartFooter.hidden = true;
            cartMore.hidden = true;
            return;
          }

          cartEmpty.hidden = true;
          cartFooter.hidden = false;
          cartSubtotal.textContent = formatShopMoney(cart.total_price || 0);

          items.slice(0, PREVIEW_LIMIT).forEach(function (item) {
            var li = document.createElement("li");
            var link = document.createElement("a");
            link.href = SHOP + (item.url || "/cart");
            var imageSrc = item.image || (item.featured_image && item.featured_image.url) || "";
            if (imageSrc) {
              var img = document.createElement("img");
              img.src = imageSrc;
              img.alt = item.product_title || item.title || "";
              link.appendChild(img);
            }
            var copy = document.createElement("span");
            copy.className = "nav-cart-item-copy";
            var title = document.createElement("span");
            title.className = "nav-cart-item-title";
            title.textContent = item.product_title || item.title || "Item";
            copy.appendChild(title);
            var metaParts = [];
            if (item.variant_title && item.variant_title !== "Default Title") metaParts.push(item.variant_title);
            if (item.quantity > 1) metaParts.push("Qty " + item.quantity);
            if (metaParts.length) {
              var meta = document.createElement("span");
              meta.className = "nav-cart-item-meta";
              meta.textContent = metaParts.join(" · ");
              copy.appendChild(meta);
            }
            link.appendChild(copy);
            var price = document.createElement("span");
            price.className = "nav-cart-item-price";
            price.textContent = formatShopMoney(item.final_line_price != null ? item.final_line_price : item.line_price);
            link.appendChild(price);
            li.appendChild(link);
            cartList.appendChild(li);
          });

          if (itemCount > PREVIEW_LIMIT) {
            cartMore.hidden = false;
            cartMore.textContent = "+" + (itemCount - PREVIEW_LIMIT) + " more in your cart";
          } else {
            cartMore.hidden = true;
          }
        }

        function fetchCartPreview() {
          var requestId = ++cartRequest;
          fetch(SHOP + "/cart.js", { credentials: "include", mode: "cors" })
            .then(function (res) {
              if (!res.ok) throw new Error("Cart fetch failed");
              return res.json();
            })
            .then(function (cart) {
              if (requestId !== cartRequest) return;
              renderCartPreview(cart);
            })
            .catch(function () {
              if (requestId !== cartRequest) return;
              renderCartPreview({ item_count: 0, items: [], total_price: 0 });
            });
        }

        function setCartOpen(isOpen) {
          cartWrap.classList.toggle("is-open", isOpen);
          cartTrigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
          cartDropdown.hidden = !isOpen;
          if (isOpen) {
            if (window.closeMegaMenus) window.closeMegaMenus();
            if (window.closeHeaderSearch) window.closeHeaderSearch();
            if (window.closeWishlistDropdown) window.closeWishlistDropdown();
            if (window.closeSocialDropdown) window.closeSocialDropdown();
            fetchCartPreview();
          }
        }

        function closeCartPreview() {
          clearTimeout(closeTimer);
          setCartOpen(false);
        }

        window.closeCartPreview = closeCartPreview;
        window.refreshCartPreview = fetchCartPreview;

        cartWrap.addEventListener("mouseenter", function () {
          clearTimeout(closeTimer);
          setCartOpen(true);
        });

        cartWrap.addEventListener("mouseleave", function () {
          closeTimer = setTimeout(closeCartPreview, 160);
        });

        fetchCartPreview();
      })();

      (function initMegaSplitCarousels() {
        var INTERVAL_MS = 4000;
        var carousels = document.querySelectorAll("[data-mega-carousel]");

        carousels.forEach(function (carousel) {
          var panel = carousel.closest(".nav-mega");
          if (!panel) return;

          var slides = carousel.querySelectorAll(".nav-mega-split-slide");
          if (slides.length < 2) return;

          var index = 0;
          var timer = null;

          function showSlide(next) {
            slides[index].classList.remove("is-active");
            index = next;
            slides[index].classList.add("is-active");
          }

          function tick() {
            showSlide((index + 1) % slides.length);
            timer = setTimeout(tick, INTERVAL_MS);
          }

          function start() {
            if (timer) return;
            timer = setTimeout(tick, INTERVAL_MS);
          }

          function stop() {
            if (!timer) return;
            clearTimeout(timer);
            timer = null;
            showSlide(0);
          }

          var observer = new MutationObserver(function () {
            if (panel.classList.contains("is-active")) start();
            else stop();
          });
          observer.observe(panel, { attributes: true, attributeFilter: ["class"] });
        });
      })();
    })();

    var footerFitmatchLink = document.getElementById("footer-fitmatch-link");
    if (footerFitmatchLink) {
      footerFitmatchLink.addEventListener("click", function (e) {
        e.preventDefault();
        if (window.openFitMatchMega) window.openFitMatchMega();
      });
    }

    (function initFitMatchCalc() {
      var calcBtn = document.getElementById("fitmatch-calc-btn");
      var output = document.getElementById("fitmatch-output");
      var unitBtns = document.querySelectorAll(".fitmatch-unit-btn");
      if (!calcBtn || !output || !unitBtns.length) return;

      var currentLengthUnit = "in";
      var currentWeightUnit = "lb";
      var IN_TO_CM = 2.54;
      var LB_TO_KG = 0.453592;

      var SIZE_CHART = {
        in: [
          { size: "XS", bust: "32-34", waist: "24-26", hips: "34-36" },
          { size: "S", bust: "34-36", waist: "26-28", hips: "36-38" },
          { size: "M", bust: "36-38", waist: "28-30", hips: "38-41" },
          { size: "L", bust: "38-41", waist: "30-33", hips: "41-44" },
          { size: "XL", bust: "41-44", waist: "33-36", hips: "44-47" }
        ],
        cm: [
          { size: "XS", bust: "81-86", waist: "61-66", hips: "86-91" },
          { size: "S", bust: "86-91", waist: "66-71", hips: "91-97" },
          { size: "M", bust: "91-97", waist: "71-76", hips: "97-104" },
          { size: "L", bust: "97-104", waist: "76-84", hips: "104-112" },
          { size: "XL", bust: "104-112", waist: "84-91", hips: "112-119" }
        ]
      };

      var measureFields = ["fitmatch-height", "fitmatch-bust", "fitmatch-waist", "fitmatch-hips", "fitmatch-thigh"];

      function bodyShape(bust, waist, hips) {
        if (hips - bust > 3) return "Pear";
        if (bust - hips > 3) return "Inverted Triangle";
        if (waist < hips * 0.75) return "Hourglass";
        return "Athletic";
      }

      function getSizeFromWaist(waistInches) {
        if (waistInches <= 26) return "XS";
        if (waistInches <= 28) return "S";
        if (waistInches <= 30) return "M";
        if (waistInches <= 33) return "L";
        return "XL";
      }

      function toInches(value, unit) {
        return unit === "cm" ? value / IN_TO_CM : value;
      }

      function updateLengthLabels(unit) {
        document.getElementById("fitmatch-label-height").firstChild.textContent =
          unit === "cm" ? "Height (cm)" : "Height (inches)";
        document.getElementById("fitmatch-label-bust").firstChild.textContent =
          unit === "cm" ? "Bust (cm)" : "Bust (in)";
        document.getElementById("fitmatch-label-waist").firstChild.textContent =
          unit === "cm" ? "Waist (cm)" : "Waist (in)";
        document.getElementById("fitmatch-label-hips").firstChild.textContent =
          unit === "cm" ? "Hips (cm)" : "Hips (in)";
        document.getElementById("fitmatch-label-thigh").firstChild.textContent =
          unit === "cm" ? "Thigh (cm)" : "Thigh (in)";
      }

      function updateWeightLabel() {
        document.getElementById("fitmatch-label-weight").firstChild.textContent =
          currentWeightUnit === "kg" ? "Weight (kg)" : "Weight (lbs)";
      }

      function setSwitchActive(switchType, unit) {
        unitBtns.forEach(function (btn) {
          if (btn.getAttribute("data-switch") === switchType) {
            btn.classList.toggle("is-active", btn.getAttribute("data-unit") === unit);
          }
        });
      }

      function updateSizeChart(unit) {
        SIZE_CHART[unit].forEach(function (row) {
          var chartRow = document.getElementById("fitmatch-size-" + row.size);
          if (!chartRow) return;
          chartRow.cells[1].textContent = row.bust;
          chartRow.cells[2].textContent = row.waist;
          chartRow.cells[3].textContent = row.hips;
        });
      }

      function convertLengthValues(fromUnit, toUnit) {
        measureFields.forEach(function (id) {
          var el = document.getElementById(id);
          var val = parseFloat(el.value);
          if (isNaN(val)) return;
          if (fromUnit === "in" && toUnit === "cm") {
            el.value = (val * IN_TO_CM).toFixed(1);
          } else if (fromUnit === "cm" && toUnit === "in") {
            el.value = (val / IN_TO_CM).toFixed(1);
          }
        });
      }

      function convertWeightValue(fromUnit, toUnit) {
        var weightEl = document.getElementById("fitmatch-weight");
        var weightVal = parseFloat(weightEl.value);
        if (isNaN(weightVal)) return;
        if (fromUnit === "lb" && toUnit === "kg") {
          weightEl.value = (weightVal * LB_TO_KG).toFixed(1);
        } else if (fromUnit === "kg" && toUnit === "lb") {
          weightEl.value = (weightVal / LB_TO_KG).toFixed(1);
        }
      }

      function setLengthUnit(unit) {
        if (unit === currentLengthUnit) return;
        convertLengthValues(currentLengthUnit, unit);
        currentLengthUnit = unit;
        setSwitchActive("length", unit);
        updateLengthLabels(unit);
        updateSizeChart(unit);
      }

      function setWeightUnit(unit) {
        if (unit === currentWeightUnit) return;
        convertWeightValue(currentWeightUnit, unit);
        currentWeightUnit = unit;
        setSwitchActive("weight", unit);
        updateWeightLabel();
      }

      unitBtns.forEach(function (btn) {
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          var switchType = btn.getAttribute("data-switch");
          var unit = btn.getAttribute("data-unit");
          if (switchType === "length") setLengthUnit(unit);
          if (switchType === "weight") setWeightUnit(unit);
        });
      });

      var FITMATCH_STYLE_COLORS = {
        "High-Waist Leggings": [
          { name: "Rose Ballet", hex: "#C77B8B" },
          { name: "Buttercream", hex: "#F5E6C8" },
          { name: "Volt Blue", hex: "#2563EB" },
          { name: "Red Means Go", hex: "#C41E3A" },
          { name: "Glowstone", hex: "#D4C4A8" },
          { name: "Harvest", hex: "#C4A574" }
        ],
        "Sports Bras": [
          { name: "Rose Ballet", hex: "#C77B8B" },
          { name: "Buttercream", hex: "#F5E6C8" },
          { name: "Berry Mood", hex: "#8B3A62" },
          { name: "Red Means Go", hex: "#C41E3A" },
          { name: "Glowstone", hex: "#D4C4A8" },
          { name: "Harvest", hex: "#C4A574" },
          { name: "Terracotta", hex: "#C86B4A" },
          { name: "Military Green", hex: "#4B5320" }
        ],
        "Matching Sets": [
          { name: "Rose Ballet", hex: "#C77B8B" },
          { name: "Berry Mood", hex: "#8B3A62" },
          { name: "Volt Blue", hex: "#2563EB" },
          { name: "Red Means Go", hex: "#C41E3A" },
          { name: "Glowstone", hex: "#D4C4A8" },
          { name: "Harvest", hex: "#C4A574" },
          { name: "Terracotta", hex: "#C86B4A" },
          { name: "Military Green", hex: "#4B5320" }
        ],
        "Wrap Tops": [
          { name: "Rose Ballet", hex: "#C77B8B" }
        ],
        "Wide Leg Pants": [
          { name: "Berry Mood", hex: "#8B3A62" }
        ],
        "Sweatpants": [
          { name: "Pull Up", hex: "#E8843A" },
          { name: "In Goal", hex: "#D4A017" },
          { name: "Pace Change", hex: "#5B8FB9" },
          { name: "Lay Up", hex: "#1A1418" }
        ],
        "Rose Ballet Set": [
          { name: "Rose Ballet", hex: "#C77B8B" }
        ],
        "ButterCream Edit": [
          { name: "Buttercream", hex: "#F5E6C8" }
        ],
        "Volt Blue Collection": [
          { name: "Volt Blue", hex: "#2563EB" }
        ],
        "Bodyluxe Jumpsuits": [
          { name: "Midnight", hex: "#1A1A2E" },
          { name: "Nude", hex: "#C9A88E" },
          { name: "Steel", hex: "#6B7280" },
          { name: "Aqua", hex: "#2DD4BF" }
        ],
        "Studio Jackets": [
          { name: "Cloud Nine", hex: "#C8C0C8" }
        ],
        "Power Soft Leggings": [
          { name: "Rose Ballet", hex: "#C77B8B" },
          { name: "Buttercream", hex: "#F5E6C8" },
          { name: "Berry Mood", hex: "#8B3A62" }
        ]
      };

      var FITMATCH_STYLES = {
        "High-Waist Leggings": {
          href: SHOP + "/collections/leggings",
          blurb: "Everyday stretch with stay-put waist coverage"
        },
        "Sports Bras": {
          href: SHOP + "/collections/crop-top",
          blurb: "Supportive lift for training and studio work"
        },
        "Matching Sets": {
          href: SHOP + "/collections/matching-sets",
          blurb: "Coordinated top-and-bottom looks in one size"
        },
        "Wrap Tops": {
          href: SHOP + "/collections/wrap-top",
          blurb: "Easy layering with adjustable coverage"
        },
        "Wide Leg Pants": {
          href: SHOP + "/collections/shop-all/products/berry-mood-straight-leg-pant",
          blurb: "Relaxed drape from studio to street"
        },
        "Sweatpants": {
          href: SHOP + "/collections/sweatpants",
          blurb: "Soft recovery layers with an easy fit"
        },
        "Rose Ballet Set": {
          href: SHOP + "/collections/rose-ballet-set",
          blurb: "Soft sculpting with a feminine silhouette"
        },
        "ButterCream Edit": {
          href: SHOP + "/collections/buttercream-edit",
          blurb: "Buttery-soft pieces for low-impact days"
        },
        "Volt Blue Collection": {
          href: SHOP + "/collections/volt-blue-collection",
          blurb: "Bold compression for high-output sessions"
        },
        "Bodyluxe Jumpsuits": {
          href: SHOP + "/collections/bodyluxe-colecction/jumpsuits-bodysuits",
          blurb: "One-and-done coverage with sleek lines"
        },
        "Studio Jackets": {
          href: SHOP + "/collections/shop-all/products/studio-chic-jacket",
          blurb: "Light structure for warm-ups and layering"
        },
        "Power Soft Leggings": {
          href: SHOP + "/collections/ballet-rose",
          blurb: "Second-skin feel with gentle hold"
        }
      };

      var ACTIVITY_STYLES = {
        Yoga: ["Wrap Tops", "High-Waist Leggings", "Matching Sets", "ButterCream Edit", "Power Soft Leggings"],
        Pilates: ["High-Waist Leggings", "Sports Bras", "Wrap Tops", "Power Soft Leggings", "Matching Sets"],
        Gym: ["Sports Bras", "High-Waist Leggings", "Matching Sets", "Rose Ballet Set", "Volt Blue Collection"],
        Running: ["High-Waist Leggings", "Sports Bras", "Volt Blue Collection", "Matching Sets"],
        Lifestyle: ["Wide Leg Pants", "Sweatpants", "Wrap Tops", "Matching Sets", "ButterCream Edit"],
        CrossFit: ["Sports Bras", "High-Waist Leggings", "Matching Sets", "Volt Blue Collection", "Bodyluxe Jumpsuits"]
      };

      var FIT_STYLES = {
        Relaxed: ["Sweatpants", "Wide Leg Pants", "Wrap Tops", "ButterCream Edit"],
        Standard: ["Matching Sets", "High-Waist Leggings", "Sports Bras", "Wrap Tops"],
        Sculpting: ["Rose Ballet Set", "High-Waist Leggings", "Sports Bras", "Matching Sets", "Power Soft Leggings"],
        Compression: ["Volt Blue Collection", "High-Waist Leggings", "Sports Bras", "Matching Sets", "Bodyluxe Jumpsuits"],
        "Maximum Compression": ["Volt Blue Collection", "High-Waist Leggings", "Sports Bras", "Bodyluxe Jumpsuits", "Matching Sets"]
      };

      var SHAPE_STYLES = {
        Pear: ["Wide Leg Pants", "Rose Ballet Set", "High-Waist Leggings", "Matching Sets"],
        Hourglass: ["Matching Sets", "Rose Ballet Set", "High-Waist Leggings", "Sports Bras"],
        Athletic: ["Sports Bras", "Volt Blue Collection", "High-Waist Leggings", "Bodyluxe Jumpsuits"],
        "Inverted Triangle": ["Wide Leg Pants", "Wrap Tops", "Matching Sets", "Sweatpants"]
      };

      var SIZE_STYLES = {
        XS: ["Sports Bras", "Wrap Tops", "Power Soft Leggings"],
        S: ["Sports Bras", "Wrap Tops", "Matching Sets"],
        M: ["Matching Sets", "High-Waist Leggings", "Sports Bras"],
        L: ["Wide Leg Pants", "Wrap Tops", "Matching Sets", "High-Waist Leggings"],
        XL: ["Wide Leg Pants", "Sweatpants", "Wrap Tops", "Matching Sets"]
      };

      function scoreStyle(name, activity, fit, shape, size) {
        var score = 0;
        (ACTIVITY_STYLES[activity] || []).forEach(function (item, index) {
          if (item === name) score += 6 - Math.min(index, 5);
        });
        (FIT_STYLES[fit] || []).forEach(function (item, index) {
          if (item === name) score += 6 - Math.min(index, 5);
        });
        (SHAPE_STYLES[shape] || []).forEach(function (item, index) {
          if (item === name) score += 3 - Math.min(index, 2);
        });
        (SIZE_STYLES[size] || []).forEach(function (item, index) {
          if (item === name) score += 2 - Math.min(index, 1);
        });
        return score;
      }

      function getStyleRecommendations(activity, fit, size, shape) {
        return Object.keys(FITMATCH_STYLES)
          .map(function (name) {
            return {
              name: name,
              href: FITMATCH_STYLES[name].href,
              blurb: FITMATCH_STYLES[name].blurb,
              score: scoreStyle(name, activity, fit, shape, size)
            };
          })
          .filter(function (item) { return item.score > 0; })
          .sort(function (a, b) { return b.score - a.score; })
          .slice(0, 5);
      }

      function buildStyleSwatchesHtml(styleName) {
        var colors = FITMATCH_STYLE_COLORS[styleName] || [];
        if (!colors.length) return "";

        var swatches = colors.map(function (color) {
          return "<span class=\"fitmatch-style-swatch\" style=\"background-color:" + color.hex + "\" title=\"" +
            color.name + "\" aria-label=\"" + color.name + "\"></span>";
        }).join("");

        return "<div class=\"fitmatch-style-colors\" role=\"list\" aria-label=\"Available colors for " + styleName + "\">" +
          swatches + "</div>";
      }

      function buildStyleCapsuleHtml(activity, fit, size, shape) {
        var picks = getStyleRecommendations(activity, fit, size, shape);
        if (!picks.length) return "";

        var listHtml = picks.map(function (pick) {
          return "<li><div class=\"fitmatch-style-row\"><a href=\"" + pick.href + "\">" + pick.name +
            "</a>" + buildStyleSwatchesHtml(pick.name) + "</div><span>" +
            pick.blurb + " · Size " + size + " · " + activity + " · " + fit + " fit</span></li>";
        }).join("");

        return "<div class=\"fitmatch-style-capsule\"><p class=\"fitmatch-style-capsule-title\">Best activewear for you</p><ul class=\"fitmatch-style-list\">" +
          listHtml + "</ul></div>";
      }

      calcBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        var bust = toInches(parseFloat(document.getElementById("fitmatch-bust").value), currentLengthUnit);
        var waist = toInches(parseFloat(document.getElementById("fitmatch-waist").value), currentLengthUnit);
        var hips = toInches(parseFloat(document.getElementById("fitmatch-hips").value), currentLengthUnit);
        var activity = document.getElementById("fitmatch-activity").value;
        var fit = document.getElementById("fitmatch-fit").value;
        var size = getSizeFromWaist(waist);

        if (isNaN(bust) || isNaN(waist) || isNaN(hips)) {
          output.innerHTML = "<p>Enter your bust, waist, and hip measurements to get your size and style picks.</p>";
          document.querySelectorAll(".fitmatch-calc-table tbody tr").forEach(function (row) {
            row.classList.remove("highlight");
          });
          return;
        }

        var shape = bodyShape(bust, waist, hips);
        var compression = "Medium";
        if (fit === "Compression") compression = "High";
        if (fit === "Maximum Compression") compression = "Extreme";
        if (fit === "Relaxed") compression = "Light";
        if (fit === "Sculpting") compression = "Medium-High";

        var material = "78% Nylon / 22% Elastane";
        if (shape === "Pear") material = "78% Nylon / 22% Elastane";
        if (shape === "Hourglass") material = "76% Nylon / 24% Elastane";
        if (shape === "Athletic") material = "80% Nylon / 20% Elastane";

        document.querySelectorAll(".fitmatch-calc-table tbody tr").forEach(function (row) {
          row.classList.remove("highlight");
        });
        var sizeRow = document.getElementById("fitmatch-size-" + size);
        if (sizeRow) sizeRow.classList.add("highlight");

        var unitLabel = currentLengthUnit === "cm" ? "cm" : "in";

        output.innerHTML =
          '<div class="fitmatch-calc-score">' + size + "</div>" +
          "<p><strong>Body Shape:</strong> " + shape + "</p>" +
          "<p><strong>Recommended Size:</strong> " + size + "</p>" +
          "<p><strong>Compression:</strong> " + compression + "</p>" +
          "<p><strong>Suggested Fabric:</strong> " + material + "</p>" +
          "<p><strong>Activity:</strong> " + activity + "</p>" +
          "<p><strong>Fit Preference:</strong> " + fit + "</p>" +
          "<p><strong>Units:</strong> " + unitLabel.toUpperCase() + "</p>" +
          "<p><strong>Confidence Score:</strong> 96%</p>" +
          buildStyleCapsuleHtml(activity, fit, size, shape);
      });
    })();

    var logo = document.getElementById("site-logo");
    if (logo && (window.__22N_CONFIG__.logoUrl || window.__22N_CONFIG__.imagesBase)) {
      logo.src = logoSrc();
    }

    var footerLogo = document.getElementById("footer-logo");
    if (footerLogo && (window.__22N_CONFIG__.logoUrl || window.__22N_CONFIG__.imagesBase)) {
      footerLogo.src = logoSrc();
    }

    (function initAnnouncementRotator() {
      var messages = [
        "Welcome to 22 natiON shop",
        "See our set deals for all your workout needs",
        "Our fabrics are of the strongest yet softest",
        "See our new arrival collection"
      ];
      var el = document.getElementById("announcement-message");
      if (!el) return;

      var index = 0;
      var cycleTimer = null;
      var fadeTimer = null;
      var ROTATE_MS = 15000;
      var FADE_MS = 400;

      function showMessage(text) {
        if (fadeTimer) clearTimeout(fadeTimer);
        el.classList.add("is-fading");
        fadeTimer = setTimeout(function () {
          el.textContent = text;
          el.classList.remove("is-fading");
          fadeTimer = null;
        }, FADE_MS);
      }

      function nextCycle() {
        showMessage(messages[index]);
        index = (index + 1) % messages.length;
        cycleTimer = setTimeout(nextCycle, ROTATE_MS);
      }

      el.textContent = messages[0];
      index = 1;
      cycleTimer = setTimeout(nextCycle, ROTATE_MS);
    })();

    (function initNewsletterForm() {
      function bindNewsletterForm(formId, emailId, submitId, messageId) {
        var form = document.getElementById(formId);
        var messageEl = document.getElementById(messageId);
        var submitBtn = document.getElementById(submitId);
        if (!form || !messageEl || !submitBtn) return;

        function showNewsletterMessage(text, type) {
          messageEl.hidden = false;
          messageEl.textContent = text;
          messageEl.classList.remove("is-success", "is-error");
          if (type) messageEl.classList.add(type === "success" ? "is-success" : "is-error");
        }

        form.addEventListener("submit", function (event) {
          event.preventDefault();
          var emailInput = document.getElementById(emailId);
          var email = emailInput ? emailInput.value.trim() : "";
          if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            showNewsletterMessage("Please enter a valid email address.", "error");
            return;
          }

          var defaultLabel = submitBtn.textContent || submitBtn.getAttribute("aria-label") || "Subscribe";
          submitBtn.disabled = true;
          if (submitBtn.textContent) submitBtn.textContent = "Sending…";
          messageEl.hidden = true;

          fetch(window.__22N_CONFIG__.apiBase + '/api/newsletter', {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email: email })
          })
            .then(function (res) {
              return res.json().catch(function () { return {}; }).then(function (data) {
                if (!res.ok) throw new Error(data.error || "Unable to subscribe right now.");
                return data;
              });
            })
            .then(function (data) {
              showNewsletterMessage(data.message || "Thank you for signing up!", "success");
              form.reset();
            })
            .catch(function (err) {
              showNewsletterMessage(err.message || "Unable to subscribe right now.", "error");
            })
            .finally(function () {
              submitBtn.disabled = false;
              if (submitBtn.textContent === "Sending…") submitBtn.textContent = defaultLabel;
            });
        });
      }

      bindNewsletterForm("newsletter-form", "newsletter-email", "newsletter-submit", "newsletter-message");
      bindNewsletterForm("prefooter-newsletter-form", "prefooter-newsletter-email", "prefooter-newsletter-submit", "prefooter-newsletter-message");
    })();

    (function initPreFooterShipping() {
      var wrap = document.getElementById("pre-footer-shipping-wrap");
      var trigger = document.getElementById("pre-footer-shipping-trigger");
      var panel = document.getElementById("pre-footer-shipping-panel");
      if (!wrap || !trigger || !panel) return;

      function setShippingOpen(isOpen) {
        wrap.classList.toggle("is-open", isOpen);
        trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
        panel.hidden = !isOpen;
      }

      trigger.addEventListener("click", function () {
        setShippingOpen(!wrap.classList.contains("is-open"));
      });

      document.addEventListener("click", function (event) {
        if (!wrap.classList.contains("is-open")) return;
        if (wrap.contains(event.target)) return;
        setShippingOpen(false);
      });

      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape" && wrap.classList.contains("is-open")) {
          setShippingOpen(false);
          trigger.focus();
        }
      });
    })();

    (function initWishlist() {
      var WISHLIST_COOKIE = "22n_wishlist";
      var WISHLIST_STORAGE_KEY = "22n_wishlist";
      var WISHLIST_SCHEMA_KEY = "22n_wishlist_schema";
      var WISHLIST_SCHEMA_VERSION = "3";
      var WISHLIST_MAX_AGE = 60 * 60 * 24 * 365;
      var HEART_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5S5 16 3 10.5C1.5 6.5 4 4 7 4c2 0 3.5 1.2 5 3 1.5-1.8 3-3 5-3 3 0 5.5 2.5 4 6.5C19 16 12 20.5 12 20.5z"/></svg>';
      var CHECK_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 12.5l4 4L18 8.5"/></svg>';

      function normalizeShopUrl(url) {
        return canonicalShopUrl(url);
      }

      function readWishlist() {
        var items = [];
        try {
          var stored = localStorage.getItem(WISHLIST_STORAGE_KEY);
          if (stored) {
            var parsed = JSON.parse(stored);
            if (Array.isArray(parsed)) items = parsed;
          }
        } catch (e) {}

        if (!items.length) {
          var match = document.cookie.match(new RegExp("(?:^|; )" + WISHLIST_COOKIE + "=([^;]*)"));
          if (match) {
            try {
              var legacy = JSON.parse(decodeURIComponent(match[1]));
              if (Array.isArray(legacy)) items = legacy;
            } catch (e) {}
          }
        }

        var normalized = mapWishlistItems(items);
        if (items.length && JSON.stringify(items) !== JSON.stringify(normalized)) {
          writeWishlist(normalized);
        }
        return normalized;
      }

      function mapWishlistItems(items) {
        return items.map(function (item) {
          return Object.assign({}, item, {
            url: normalizeShopUrl(item.url),
            checked: !!item.checked
          });
        });
      }

      function writeWishlist(items) {
        var normalized = mapWishlistItems(items);
        var payload = JSON.stringify(normalized);
        try {
          localStorage.setItem(WISHLIST_STORAGE_KEY, payload);
        } catch (e) {}
        try {
          document.cookie = WISHLIST_COOKIE + "=" + encodeURIComponent(payload) +
            "; path=/; max-age=" + WISHLIST_MAX_AGE + "; SameSite=Lax";
        } catch (e) {}
      }

      function clearWishlist() {
        writeWishlist([]);
        updateNavWishlistLink();
        refreshWishlistHearts(document);
      }

      function removeWishlistItem(id) {
        if (!id) return;
        var items = readWishlist().filter(function (item) { return item.id !== id; });
        writeWishlist(items);
        updateNavWishlistLink();
        refreshWishlistHearts(document);
      }

      window.clearWishlist = clearWishlist;

      function getWishHeartHost(slot) {
        var media = slot.closest(".spotlight-card-media");
        return media || slot;
      }

      function wishlistId(url) {
        var shopAllMatch = (url || "").match(/\/collections\/shop-all\/products\/([^/?#]+)/i);
        if (shopAllMatch) return shopAllMatch[1];
        var productMatch = (url || "").match(/\/products\/([^/?#]+)/i);
        if (productMatch) return productMatch[1];
        var collectionMatch = (url || "").match(/\/collections\/([^/?#]+)/i);
        if (collectionMatch) return "collection:" + collectionMatch[1];
        return url || "";
      }

      function getSlotImage(slot) {
        var img = slot.querySelector("img");
        return img && img.src ? img.src : "";
      }

      function resolveSlotMeta(slot) {
        var href = slot.getAttribute("data-href") || "";
        var title = slot.getAttribute("data-wish-title") || slot.getAttribute("data-alt") || "";
        var ugcItem = slot.closest(".ugc-item[data-href]");
        var spotlightCard = slot.closest(".spotlight-card");

        if (!href && ugcItem) href = ugcItem.getAttribute("data-href") || "";
        if (!href && spotlightCard) {
          var imageLink = spotlightCard.querySelector(".spotlight-card-image-link");
          if (imageLink) href = imageLink.getAttribute("href") || "";
        }
        if (!title && spotlightCard) {
          var spotlightTitle = spotlightCard.querySelector(".spotlight-card-title");
          if (spotlightTitle) title = spotlightTitle.textContent.trim();
        }
        if (!title && ugcItem) {
          var ugcAlt = slot.getAttribute("data-alt");
          if (ugcAlt) title = ugcAlt;
        }

        return { href: href, title: title, image: getSlotImage(slot) };
      }

      function isSaved(id) {
        return readWishlist().some(function (item) { return item.id === id; });
      }

      function syncHeartButton(btn, id) {
        var saved = isSaved(id);
        btn.classList.toggle("is-saved", saved);
        btn.setAttribute("aria-pressed", saved ? "true" : "false");
        btn.setAttribute("aria-label", saved ? "Remove from wishlist" : "Add to wishlist");
      }

      function updateNavWishlistLink() {
        var trigger = document.getElementById("nav-wishlist-trigger");
        if (!trigger) return;
        var count = readWishlist().length;
        trigger.classList.toggle("has-wishlist-items", count > 0);
        trigger.setAttribute("aria-label", count ? "Wishlist (" + count + " items)" : "Wishlist");
        renderWishlistDropdown();
      }

      function renderWishlistDropdown() {
        var list = document.getElementById("nav-wishlist-list");
        var empty = document.getElementById("nav-wishlist-empty");
        if (!list || !empty) return;

        var items = readWishlist().slice().sort(function (a, b) {
          return (b.addedAt || 0) - (a.addedAt || 0);
        });

        list.innerHTML = "";
        empty.hidden = items.length > 0;

        items.forEach(function (item) {
          var li = document.createElement("li");
          li.className = "nav-wishlist-item";
          li.setAttribute("data-wish-id", item.id);

          var link = document.createElement("a");
          var shopUrl = normalizeShopUrl(item.url);
          link.href = shopUrl;
          link.setAttribute("data-shop-url", shopUrl);
          if (item.image) {
            var img = document.createElement("img");
            img.src = item.image;
            img.alt = item.title || "";
            link.appendChild(img);
          }
          var title = document.createElement("span");
          title.className = "nav-wishlist-list-title";
          title.textContent = item.title || "Saved item";
          link.appendChild(title);
          li.appendChild(link);

          var checkBtn = document.createElement("button");
          checkBtn.type = "button";
          checkBtn.className = "nav-wishlist-check";
          checkBtn.setAttribute("data-wish-id", item.id);
          checkBtn.setAttribute("aria-label", "Remove " + (item.title || "item") + " from wishlist");
          checkBtn.innerHTML = CHECK_SVG;
          li.appendChild(checkBtn);

          list.appendChild(li);
        });
      }

      function toggleWishlist(meta) {
        if (!meta.href) return false;
        var id = wishlistId(meta.href);
        var items = readWishlist();
        var index = items.findIndex(function (item) { return item.id === id; });

        if (index >= 0) {
          items.splice(index, 1);
        } else {
          items.push({
            id: id,
            title: meta.title || id,
            url: normalizeShopUrl(meta.href),
            image: meta.image || "",
            addedAt: Date.now(),
            checked: false
          });
        }

        writeWishlist(items);
        updateNavWishlistLink();
        refreshWishlistHearts(document);
        return index < 0;
      }

      function bindWishlistHeart(slot) {
        if (!slot) return;
        var meta = resolveSlotMeta(slot);
        if (!meta.href) return;

        slot.setAttribute("data-href", meta.href);
        if (meta.title) slot.setAttribute("data-wish-title", meta.title);

        var id = wishlistId(meta.href);
        var host = getWishHeartHost(slot);
        var btn = host.querySelector(".image-wish-btn");

        if (slot.dataset.wishBound === "1") {
          if (btn) syncHeartButton(btn, id);
          return;
        }

        if (!btn) {
          btn = document.createElement("button");
          btn.type = "button";
          btn.className = "image-wish-btn";
          btn.innerHTML = HEART_SVG;
          host.appendChild(btn);
        }

        syncHeartButton(btn, id);

        btn.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();
          var latest = resolveSlotMeta(slot);
          toggleWishlist(latest);
          syncHeartButton(btn, wishlistId(latest.href));
        });

        if (!slot.dataset.wishClickBound) {
          slot.dataset.wishClickBound = "1";
          var hasNativeLink =
            slot.closest("a[href]") ||
            slot.querySelector("a[href]") ||
            slot.closest(".spotlight-card-image-link") ||
            slot.closest(".ugc-item[data-href]") ||
            slot.classList.contains("n22-storefront-wish-slot");
          if (!hasNativeLink) {
            slot.addEventListener("click", function (event) {
              if (event.target.closest(".image-wish-btn")) return;
              var latestHref = slot.getAttribute("data-href");
              if (latestHref) window.location.href = latestHref;
            });
          }
        }

        slot.dataset.wishBound = "1";
      }

      function currentProductPageMeta() {
        var path = window.location.pathname || "";
        if (!/\/products\//i.test(path)) return null;
        var handleMatch = path.match(/\/products\/([^/?#]+)/i);
        if (!handleMatch) return null;
        var titleEl =
          document.querySelector('.product-single__meta h1, .product__title, h1[itemprop="name"], .template-product h1.h2, .template-product h1') ||
          document.querySelector('meta[property="og:title"]');
        var title = "";
        if (titleEl) {
          title = titleEl.getAttribute("content") || titleEl.textContent || "";
          title = title.replace(/\s+/g, " ").trim();
        }
        var img =
          document.querySelector(".product__photo.top-image img.lazyload, .product__photo.top-image img, .product__photo img.lazyload, .product__photo img");
        return {
          href: shopProductUrl(handleMatch[1]),
          title: title || handleMatch[1].replace(/-/g, " "),
          image: img ? (img.currentSrc || img.src || img.getAttribute("data-src") || "") : ""
        };
      }

      function prepareStorefrontWishlistSlots(scope) {
        var root = scope || document;

        root.querySelectorAll(".product-item").forEach(function (item) {
          if (item.dataset.n22WishPrepared === "1") return;
          var link = item.querySelector("a.product-item__link[href*='/products/'], a.product-item__link[href*='/collections/']");
          if (!link) return;
          var href = link.getAttribute("href") || "";
          if (!/\/products\//i.test(href) && !/\/collections\//i.test(href)) return;

          var host = item.querySelector(".product-item__link-wrapper") || item;
          host.classList.add("image-slot", "n22-storefront-wish-slot");
          host.setAttribute("data-href", canonicalShopUrl(href));
          var titleEl = item.querySelector(".product-item__title");
          var title = (titleEl && titleEl.textContent.trim()) || link.getAttribute("title") || "";
          if (!title) {
            var img = item.querySelector("img.product-item__image, img");
            title = (img && img.getAttribute("alt")) || "";
          }
          if (title) host.setAttribute("data-wish-title", title);
          item.dataset.n22WishPrepared = "1";
        });

        var productMeta = currentProductPageMeta();
        if (productMeta && productMeta.href) {
          var photos = root.querySelectorAll(".product__photo");
          if (!photos.length) {
            var fallback = root.querySelector(".product-single__photos, .product__photos, [data-product-images]");
            if (fallback) photos = [fallback];
          }
          Array.prototype.forEach.call(photos, function (photo, index) {
            if (photo.dataset.n22WishPrepared === "1") return;
            // One heart per product page (primary / first visible photo) — gallery duplicates same product
            if (index > 0) return;
            photo.classList.add("image-slot", "n22-storefront-wish-slot");
            photo.setAttribute("data-href", productMeta.href);
            if (productMeta.title) photo.setAttribute("data-wish-title", productMeta.title);
            photo.dataset.n22WishPrepared = "1";
          });
        }

        root.querySelectorAll(".feature-row.power-soft-feature-row, .power-soft-feature-row").forEach(function (row) {
          if (row.dataset.n22WishPrepared === "1") return;
          var link = row.querySelector("a[href*='/products/'], a[href*='/collections/shop-all/products/']");
          if (!link) return;
          var href = link.getAttribute("href") || "";
          if (!/\/products\//i.test(href)) return;
          var host =
            row.querySelector(".feature-row__image-wrapper, .feature-row__item--image, .feature-row__image") ||
            row.querySelector(".grid__item.feature-row__item:not(.feature-row__text)");
          if (!host) host = link;
          if (host.tagName === "IMG") host = host.parentElement || host;
          host.classList.add("image-slot", "n22-storefront-wish-slot");
          host.setAttribute("data-href", canonicalShopUrl(href));
          var title =
            (row.querySelector("h2, h3, .feature-row__title") &&
              row.querySelector("h2, h3, .feature-row__title").textContent.trim()) ||
            link.textContent.trim() ||
            "";
          if (title) host.setAttribute("data-wish-title", title.replace(/\s+/g, " ").trim());
          row.dataset.n22WishPrepared = "1";
        });

        root.querySelectorAll(".collection-list-grid__item, .collection-grid__item").forEach(function (item) {
          if (item.dataset.n22WishPrepared === "1") return;
          var link = item.querySelector("a.collection-grid__link[href], a[href*='/collections/']");
          if (!link) return;
          var href = link.getAttribute("href") || "";
          if (!/\/collections\//i.test(href) || /\/products\//i.test(href)) return;
          var host =
            item.querySelector(".collection-list-grid__image-wrapper, .collection-list-grid__image, .collection-grid__image, .grid__image") ||
            link;
          host.classList.add("image-slot", "n22-storefront-wish-slot");
          host.setAttribute("data-href", canonicalShopUrl(href));
          var titleEl = item.querySelector(".collection-list-grid__title, .product-item__title, h2, h3");
          if (titleEl) host.setAttribute("data-wish-title", titleEl.textContent.replace(/\s+/g, " ").trim());
          item.dataset.n22WishPrepared = "1";
        });

        // Cart line items
        root.querySelectorAll(".cart__row, .cart-item, tr.cart__row").forEach(function (row) {
          if (row.dataset.n22WishPrepared === "1") return;
          var link = row.querySelector("a[href*='/products/']");
          if (!link) return;
          var host = row.querySelector(".cart__image, .cart-item__image, td.cart__meta-image, .cart__row-image") || link.parentElement;
          if (!host) return;
          host.classList.add("image-slot", "n22-storefront-wish-slot");
          host.setAttribute("data-href", canonicalShopUrl(link.getAttribute("href") || ""));
          var titleEl = row.querySelector(".cart__product-title, .cart-item__title, a[href*='/products/']");
          if (titleEl) host.setAttribute("data-wish-title", titleEl.textContent.replace(/\s+/g, " ").trim());
          row.dataset.n22WishPrepared = "1";
        });
      }

      function refreshWishlistHearts(root) {
        var scope = root || document;
        prepareStorefrontWishlistSlots(scope);
        scope.querySelectorAll(".image-slot").forEach(function (slot) {
          if (slot.closest(".hero-grid")) return;
          bindWishlistHeart(slot);
        });
        updateNavWishlistLink();
      }

      window.refreshWishlistHearts = refreshWishlistHearts;

      document.querySelectorAll(".ugc-item[data-href]").forEach(function (item) {
        var slot = item.querySelector(".image-slot");
        if (!slot) return;
        var title = slot.getAttribute("data-alt") || "";
        slot.setAttribute("data-href", item.getAttribute("data-href") || "");
        if (title) slot.setAttribute("data-wish-title", title);
      });

      try {
        if (localStorage.getItem(WISHLIST_SCHEMA_KEY) !== WISHLIST_SCHEMA_VERSION) {
          clearWishlist();
          localStorage.setItem(WISHLIST_SCHEMA_KEY, WISHLIST_SCHEMA_VERSION);
        }
      } catch (e) {}

      refreshWishlistHearts(document);

      // Re-bind after Boundless lazyload / ajax filters if DOM updates
      if (window.MutationObserver) {
        var wishPending = null;
        var wishRefreshing = false;
        var wishObserver = new MutationObserver(function (mutations) {
          if (wishRefreshing || wishPending) return;
          var relevant = mutations.some(function (m) {
            if (m.type !== "childList") return false;
            var nodes = [];
            m.addedNodes.forEach(function (n) { nodes.push(n); });
            m.removedNodes.forEach(function (n) { nodes.push(n); });
            return nodes.some(function (n) {
              if (!n || n.nodeType !== 1) return false;
              if (n.classList && (n.classList.contains("image-wish-btn") || n.classList.contains("n22-storefront-wish-slot"))) return false;
              if (n.closest && n.closest(".image-wish-btn, #nav-wishlist-dropdown, #nav-wishlist-list")) return false;
              return !!(
                (n.matches && n.matches(".product-item, .product__photo, .feature-row, .collection-list-grid__item, .cart__row, .cart-item")) ||
                (n.querySelector && n.querySelector(".product-item, .product__photo, .feature-row, .collection-list-grid__item"))
              );
            });
          });
          if (!relevant) return;
          wishPending = window.setTimeout(function () {
            wishPending = null;
            wishRefreshing = true;
            try {
              refreshWishlistHearts(document);
            } finally {
              wishRefreshing = false;
            }
          }, 300);
        });
        wishObserver.observe(document.body, { childList: true, subtree: true });
      }

      var wishlistWrap = document.getElementById("nav-wishlist");
      var wishlistTrigger = document.getElementById("nav-wishlist-trigger");
      var wishlistDropdown = document.getElementById("nav-wishlist-dropdown");

      function setWishlistOpen(isOpen) {
        if (!wishlistWrap || !wishlistTrigger || !wishlistDropdown) return;
        wishlistWrap.classList.toggle("is-open", isOpen);
        wishlistTrigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
        wishlistDropdown.hidden = !isOpen;
        if (isOpen) {
          if (window.closeHeaderSearch) window.closeHeaderSearch();
          if (window.closeMegaMenus) window.closeMegaMenus();
          if (window.closeSocialDropdown) window.closeSocialDropdown();
          if (window.closeCartPreview) window.closeCartPreview();
          renderWishlistDropdown();
        }
      }

      function closeWishlistDropdown() {
        setWishlistOpen(false);
      }

      window.closeWishlistDropdown = closeWishlistDropdown;

      if (wishlistTrigger) {
        wishlistTrigger.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();
          setWishlistOpen(!wishlistWrap.classList.contains("is-open"));
        });
      }

      var wishlistList = document.getElementById("nav-wishlist-list");
      if (wishlistList) {
        wishlistList.addEventListener("click", function (event) {
          var checkBtn = event.target.closest(".nav-wishlist-check");
          if (checkBtn && wishlistList.contains(checkBtn)) {
            event.preventDefault();
            event.stopPropagation();
            removeWishlistItem(checkBtn.getAttribute("data-wish-id"));
            return;
          }

          var link = event.target.closest("a[data-shop-url]");
          if (!link || !wishlistList.contains(link)) return;
          event.preventDefault();
          closeWishlistDropdown();
          window.location.href = link.getAttribute("data-shop-url");
        });
      }

      document.addEventListener("click", function (e) {
        if (!wishlistWrap || !wishlistWrap.classList.contains("is-open")) return;
        if (!wishlistWrap.contains(e.target)) closeWishlistDropdown();
      });

      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") closeWishlistDropdown();
      });
    })();

    document.querySelectorAll(".ugc-item[data-href]").forEach(function (item) {
      var href = item.getAttribute("data-href") || SHOP;
      item.addEventListener("click", function (event) {
        if (event.target.closest(".image-wish-btn")) return;
        window.location.href = href;
      });
      var btn = item.querySelector(".shop-look");
      if (btn) {
        btn.addEventListener("click", function (event) {
          event.stopPropagation();
          window.location.href = href;
        });
      }
    });
  })();